// ── translations.js ── Full AR / EN translation map ──────────────────────────
// Every user-facing string in the app is defined here.
// Key naming: component_section_key  (all lower-snake)

const translations = {
  // ─────────────────────────── LANGUAGE SELECTOR ──────────────────────────────
  langSelector: {
    title: {
      ar: "اختر لغتك المفضلة",
      en: "Choose Your Preferred Language",
    },
    subtitle: {
      ar: "يمكنك تغيير اللغة في أي وقت من شريط التنقل",
      en: "You can change the language at any time from the navigation bar",
    },
    arabic: {
      ar: "العربية",
      en: "Arabic",
    },
    english: {
      ar: "الإنجليزية",
      en: "English",
    },
    arabicNative: {
      ar: "العربية",
      en: "العربية",
    },
    englishNative: {
      ar: "English",
      en: "English",
    },
    continueBtn: {
      ar: "متابعة",
      en: "Continue",
    },
    welcome: {
      ar: "مرحباً بك في",
      en: "Welcome to",
    },
  },

  // ────────────────────────────── NAVBAR ──────────────────────────────────────
  navbar: {
    currency: {
      ar: "العملات",
      en: "Currency",
    },
    payment: {
      ar: "الدفع",
      en: "Payment",
    },
    myOrders: {
      ar: "طلباتي",
      en: "My Orders",
    },
    support: {
      ar: "الدعم",
      en: "Support",
    },
    // ── قسم الملف الشخصي في شريط التنقل ──────────────────────────────────────
    profileSection: {
      ar: "الملف الشخصي",
      en: "Profile",
    },
    viewProfile: {
      ar: "عرض الملف الشخصي",
      en: "View Profile",
    },
    editProfileNav: {
      ar: "تعديل الملف الشخصي",
      en: "Edit Profile",
    },
    siteOwner: {
      ar: "♛ مالك الموقع",
      en: "♛ Site Owner",
    },
    member: {
      ar: "عضو",
      en: "Member",
    },
    guestLabel: {
      ar: "زائر مؤقت",
      en: "Guest",
    },
    specialRequest: {
      ar: "طلبات خاصة",
      en: "Special Requests",
    },
    currencyTitle: {
      ar: "محوّل العملات",
      en: "Currency Converter",
    },
    paymentTitle: {
      ar: "وسائل الدفع",
      en: "Payment Methods",
    },
    changeLang: {
      ar: "English",
      en: "عربي",
    },
    supportus: {
      ar: "ادعمنا",
      en: "Support Us",
    },
  },

  // ────────────────────────────── HOME PAGE ────────────────────────────────────
  home: {
    heroBadge: {
      ar: "أحدث التسريبات الحصرية",
      en: "Latest Exclusive Leaks",
    },
    heroTitle1: {
      ar: "أكبر مجموعة",
      en: "The Largest",
    },
    heroTitle2: {
      ar: "حصرية",
      en: "Exclusive Collection",
    },
    heroSubtitle: {
      ar: "وصول فوري لتسريبات اونلي فانز الحصرية عبر Leaks Mercy — الأعلى جودة والأكثر طلباً",
      en: "Instant access to exclusive OnlyFans leaks on Leaks Mercy — highest quality and most in demand",
    },
    statPerformer: {
      ar: "ممثل",
      en: "Performer",
    },
    statExclusive: {
      ar: "حصري",
      en: "Exclusive",
    },
    statSecure: {
      ar: "آمن",
      en: "Secure",
    },
    statEncrypted: {
      ar: "ومشفر",
      en: "& Encrypted",
    },
    eduBannerTitle: {
      ar: "جديد في تخطي الروابط؟",
      en: "New to Link Bypass?",
    },
    eduBannerDesc: {
      ar: "شاهد فيديو تعليمي قصير ويسهل عليك تخطي روابط الحزم المجانية بكل سهولة",
      en: "Watch a short tutorial video to easily bypass free package links",
    },
    eduBannerBtn: {
      ar: "تعلّم كيفية تخطي الروابط",
      en: "Learn How to Bypass Links",
    },
    filterTitle: {
      ar: "تصفية حسب الفئة",
      en: "Filter by Category",
    },
    filterAll: {
      ar: "الكل",
      en: "All",
    },
    // ── Search bar labels ──────────────────────────────────────────────────────
    searchPlaceholder: {
      ar: "ابحث عن ممثل...",
      en: "Search performer...",
    },
    searchClear: {
      ar: "مسح البحث",
      en: "Clear search",
    },
    searchCategory: {
      ar: "التصنيف",
      en: "Category",
    },
    searchResults: {
      ar: "نتيجة",
      en: "result(s)",
    },
    searchClearFilters: {
      ar: "مسح الفلاتر",
      en: "Clear filters",
    },
    // ── Sort options ───────────────────────────────────────────────────────────
    sortHot: {
      ar: "ساخن",
      en: "Hot",
    },
    sortNew: {
      ar: "جديد",
      en: "New",
    },
    sortRandom: {
      ar: "عشوائي",
      en: "Random",
    },
    sortSize: {
      ar: "الحجم",
      en: "Size",
    },
    sortOldest: {
      ar: "الأقدم",
      en: "Oldest",
    },
    // ── Section titles per sort ────────────────────────────────────────────────
    sectionNewlyAdded: {
      ar: "الأحدث إضافةً",
      en: "Newly Added",
    },
    sectionRandom: {
      ar: "عرض عشوائي",
      en: "Random Picks",
    },
    sectionLargest: {
      ar: "الأكبر حجماً",
      en: "Largest First",
    },
    sectionOldest: {
      ar: "الأقدم إضافةً",
      en: "Oldest First",
    },
    sectionAll: {
      ar: "حزم ساخنة",
      en: "Hot Bundles",
    },
    sectionCategory: {
      ar: "فئة",
      en: "Category",
    },
    available: {
      ar: "متاح",
      en: "Available",
    },
    loading: {
      ar: "جارِ التحميل...",
      en: "Loading...",
    },
    emptyCategory: {
      ar: "لا يوجد ممثلين في هذه الفئة",
      en: "No performers in this category",
    },
    footerRights: {
      ar: "© 2025 Leaks Mercy — جميع الحقوق محفوظة",
      en: "© 2025 Leaks Mercy — All Rights Reserved",
    },
    footerDisclaimer: {
      ar: "هذا الموقع للأفراد البالغين فقط +18",
      en: "This site is for adults only +18",
    },
  },

  // ───────────────────────── PERFORMER CARD ────────────────────────────────────
  card: {
    free: {
      ar: "مجاني",
      en: "Free",
    },
    linkBypass: {
      ar: "تخطي روابط",
      en: "Link Bypass",
    },
    size: {
      ar: "الحجم",
      en: "Size",
    },
    quality: {
      ar: "الجودة",
      en: "Quality",
    },
    getLink: {
      ar: "الحصول على الرابط",
      en: "Get Link",
    },
    buyPackage: {
      ar: "شراء الحزمة",
      en: "Buy Package",
    },
    openPackage: {
      ar: "فتح الحزمة",
      en: "Open Package",
    },
    purchased: {
      ar: "تم الشراء ✓",
      en: "Purchased ✓",
    },
    unlocked: {
      ar: "مفتوح",
      en: "Unlocked",
    },
    viewPackage: {
      ar: "عرض الحزمة",
      en: "View Package",
    },
    offerEnds: {
      ar: "ينتهي العرض:",
      en: "Offer ends:",
    },
    days: {
      ar: "يوم",
      en: "day",
    },
    hours: {
      ar: "ساعة",
      en: "hr",
    },
    minutes: {
      ar: "دقيقة",
      en: "min",
    },
    newBadge: {
      ar: "جديد 🆕",
      en: "New",
    },
    hotBadge: {
      ar: "رائج 🔥",
      en: "Hot 🔥",
    },
    popularBadge: {
      ar: "مشهور ⭐",
      en: "Popular ⭐",
    },
    vipBadge: {
      ar: "VIP 👑",
      en: "VIP 👑",
    },
    exclusiveBadge: {
      ar: "حصري 💎",
      en: "Exclusive 💎",
    },
    saleBadge: {
      ar: "تخفيض 💸",
      en: "Sale 💸",
    },
    bundleBadge: {
      ar: "باقة مجانية",
      en: "Bundle",
    },
    limitedBadge: {
      ar: "ينتهي قريباً ⏰",
      en: "Ending Soon ⏰",
    },
    freeBadge: {
      ar: "مجاني",
      en: "Free",
    },
    // PerformerCard specific
    purchasedBadge: {
      ar: "مشترى",
      en: "Purchased",
    },
    linkBypassBadge: {
      ar: "تخطي روابط",
      en: "Link Bypass",
    },
    discountBadge: {
      ar: "خصم",
      en: "Discount",
    },
    freeBundleBadge: {
      ar: "باكيج مجاني",
      en: "Free Bundle",
    },
    specialBundleBadge: {
      ar: "باكيج خاص",
      en: "Special Bundle",
    },
    bundleOfferTooltip: {
      ar: "عند شراء الحزمة يمكنك الحصول على أي حزمة أخرى من الموقع بشكل مجاني كهدية",
      en: "When you buy this package you can get any other package from the site for free as a gift",
    },
    customOfferTooltip: {
      ar: "عند شراء الحزمة يمكنك الحصول على حزمة من طلبك الخاص بشكل مجاني",
      en: "When you buy this package you can get a custom package of your choice for free",
    },
    availableNow: {
      ar: "متاح الآن",
      en: "Available Now",
    },
    viewFreeLink: {
      ar: "عرض الرابط المجاني",
      en: "View Free Link",
    },
    openLink: {
      ar: "فتح الرابط ✓",
      en: "Open Link ✓",
    },
    clickToEnter: {
      ar: "اضغط للدخول",
      en: "Click to Enter",
    },
    purchasedClickToOpen: {
      ar: "مشترى — اضغط لفتح",
      en: "Purchased — Click to Open",
    },
    enterPasswordBtn: {
      ar: "أدخل كلمة السر",
      en: "Enter Password",
    },
    // Share feature
    sharePackage: {
      ar: "مشاركة",
      en: "Share",
    },
    copyShareLink: {
      ar: "نسخ رابط المشاركة",
      en: "Copy Share Link",
    },
    shareLinkCopied: {
      ar: "تم نسخ الرابط ✓",
      en: "Link Copied ✓",
    },
    // Watched feature
    watchedBadge: {
      ar: "تمت المشاهدة",
      en: "Watched",
    },
  },

  // ──────────────────────── PASSWORD MODAL ─────────────────────────────────────
  modal: {
    title: {
      ar: "الوصول للحزمة",
      en: "Package Access",
    },
    alreadyUnlocked: {
      ar: "تم فتح هذه الحزمة مسبقاً",
      en: "This package is already unlocked",
    },
    megaLink: {
      ar: "رابط الميجا",
      en: "MEGA Link",
    },
    openMega: {
      ar: "فتح رابط الميجا",
      en: "Open MEGA Link",
    },
    passwordPlaceholder: {
      ar: "أدخل كلمة السر",
      en: "Enter password",
    },
    enterPassword: {
      ar: "أدخل كلمة السر للوصول",
      en: "Enter password to access",
    },
    submit: {
      ar: "دخول",
      en: "Enter",
    },
    wrongPassword: {
      ar: "كلمة السر غير صحيحة، حاول مرة أخرى",
      en: "Incorrect password, please try again",
    },
    buyPackage: {
      ar: "شراء الحزمة",
      en: "Buy Package",
    },
    loading: {
      ar: "جارِ التحقق...",
      en: "Verifying...",
    },
    linkBypassDesc: {
      ar: "هذه الحزمة مجانية — اضغط للحصول على الرابط",
      en: "This package is free — press to get the link",
    },
    getLink: {
      ar: "الحصول على الرابط",
      en: "Get the Link",
    },
    packageInfo: {
      ar: "معلومات الحزمة",
      en: "Package Info",
    },
    sizeLabel: {
      ar: "الحجم",
      en: "Size",
    },
    qualityLabel: {
      ar: "الجودة",
      en: "Quality",
    },
    priceLabel: {
      ar: "السعر",
      en: "Price",
    },
    // PasswordModal specific
    enterMegaPassword: {
      ar: "أدخل كلمة السر للوصول إلى رابط الميجا",
      en: "Enter password to access the MEGA link",
    },
    connectingDb: {
      ar: "جارِ الاتصال...",
      en: "Connecting...",
    },
    wrongPasswordShort: {
      ar: "كلمة السر غلط",
      en: "Wrong password",
    },
    wrongPasswordContact: {
      ar: " — تواصل مع المدير للحصول على كلمة سر نشطة",
      en: " — contact admin for an active password",
    },
    openLinkBtn: {
      ar: "فتح الرابط",
      en: "Open Link",
    },
    openMegaBtn: {
      ar: "فتح رابط الميجا",
      en: "Open MEGA Link",
    },
    closeBtn: {
      ar: "إغلاق",
      en: "Close",
    },
    megaLinkLabel: {
      ar: "رابط الميجا",
      en: "MEGA Link",
    },
    megaLinkBypass: {
      ar: "رابط الميجا (تخطي روابط)",
      en: "MEGA Link (Link Bypass)",
    },
    purchasedBadge: {
      ar: "تم الشراء مسبقاً ✓",
      en: "Previously Purchased ✓",
    },
    paidHint: {
      ar: "اشترِ الحزمة للحصول على كلمة السر تلقائياً",
      en: "Buy the package to get the password automatically",
    },
    freeHint: {
      ar: "هذه الحزمة مجانية — وصول عبر صفحات الإعلانات",
      en: "This package is free — access via ad pages",
    },
  },

  // ───────────────────────────── PAYMENT PAGE ──────────────────────────────────
  payment: {
    title: {
      ar: "وسائل الدفع",
      en: "Payment Methods",
    },
    subtitle: {
      ar: "اختر طريقة الدفع المناسبة لك",
      en: "Choose the payment method that suits you",
    },
    back: {
      ar: "الرئيسية",
      en: "Home",
    },
    selectPackage: {
      ar: "اختر الحزمة",
      en: "Select Package",
    },
    packageLabel: {
      ar: "الحزمة المختارة",
      en: "Selected Package",
    },
    changePackage: {
      ar: "تغيير",
      en: "Change",
    },
    noPackage: {
      ar: "لم يتم اختيار حزمة",
      en: "No package selected",
    },
    step1: {
      ar: "ادفع المبلغ",
      en: "Make Payment",
    },
    step2: {
      ar: "ارفع إثبات الدفع",
      en: "Upload Proof",
    },
    step3: {
      ar: "انتظر التأكيد",
      en: "Wait for Confirmation",
    },
    copyNumber: {
      ar: "نسخ الرقم",
      en: "Copy Number",
    },
    copyAddress: {
      ar: "نسخ العنوان",
      en: "Copy Address",
    },
    copyPayId: {
      ar: "نسخ الـ Pay ID",
      en: "Copy Pay ID",
    },
    copied: {
      ar: "تم النسخ!",
      en: "Copied!",
    },
    scanQR: {
      ar: "امسح رمز QR",
      en: "Scan QR Code",
    },
    network: {
      ar: "الشبكة",
      en: "Network",
    },
    currency: {
      ar: "العملة",
      en: "Currency",
    },
    uploadProof: {
      ar: "رفع إثبات الدفع",
      en: "Upload Payment Proof",
    },
    uploadDesc: {
      ar: "ارفع صورة إثبات الدفع هنا",
      en: "Upload your payment proof image here",
    },
    clickToUpload: {
      ar: "اضغط لرفع صورة الإثبات",
      en: "Click to upload proof image",
    },
    yourName: {
      ar: "اسمك (اختياري)",
      en: "Your Name (optional)",
    },
    yourEmail: {
      ar: "بريدك الإلكتروني",
      en: "Your Email",
    },
    emailDesc: {
      ar: "سيُرسل إليك كلمة السر عبر البريد الإلكتروني",
      en: "Password will be sent to your email",
    },
    telegramUser: {
      ar: "يوزر تيليجرام (اختياري)",
      en: "Telegram Username (optional)",
    },
    submitProof: {
      ar: "إرسال إثبات الدفع",
      en: "Submit Payment Proof",
    },
    submitting: {
      ar: "جارِ الإرسال...",
      en: "Submitting...",
    },
    successTitle: {
      ar: "تم إرسال إثبات الدفع!",
      en: "Payment Proof Submitted!",
    },
    successDesc: {
      ar: "سيتم مراجعة إثباتك وإرسال كلمة السر خلال 24 ساعة",
      en: "Your proof will be reviewed and password sent within 24 hours",
    },
    proofId: {
      ar: "رقم الطلب",
      en: "Order ID",
    },
    copyId: {
      ar: "نسخ الرقم",
      en: "Copy ID",
    },
    backHome: {
      ar: "العودة للرئيسية",
      en: "Back to Home",
    },
    checkOrders: {
      ar: "متابعة طلباتي",
      en: "Track My Orders",
    },
    searchPlaceholder: {
      ar: "ابحث عن ممثل...",
      en: "Search for a performer...",
    },
    allCategories: {
      ar: "الكل",
      en: "All",
    },
    selectPkg: {
      ar: "اختر هذه الحزمة",
      en: "Select This Package",
    },
    noResults: {
      ar: "لا توجد نتائج",
      en: "No results found",
    },
    phoneNumber: {
      ar: "رقم الهاتف",
      en: "Phone Number",
    },
    walletAddress: {
      ar: "عنوان المحفظة",
      en: "Wallet Address",
    },
    // Payment.jsx specific hardcoded strings
    availableNow: {
      ar: "متاح الآن",
      en: "Available Now",
    },
    useNetwork: {
      ar: "استخدم شبكة",
      en: "Use network",
    },
    onlyWarning: {
      ar: "فقط — أي شبكة أخرى يُفقد فيها المال نهائياً",
      en: "only — any other network will permanently lose funds",
    },
    trc20Warning: {
      ar: "استخدم شبكة TRC20 فقط — أي شبكة أخرى يُفقد فيها المال نهائياً",
      en: "Use TRC20 network only — any other network will permanently lose funds",
    },
    cryptoCurrencyLabel: {
      ar: "العملة",
      en: "Currency",
    },
    networkLabel: {
      ar: "الشبكة",
      en: "Network",
    },
    walletAddressLabel: {
      ar: "عنوان المحفظة (USDT TRC20)",
      en: "Wallet Address (USDT TRC20)",
    },
    copyAddress: {
      ar: "نسخ العنوان",
      en: "Copy Address",
    },
    addressCopied: {
      ar: "✓ تم نسخ العنوان",
      en: "✓ Address copied",
    },
    hideQR: {
      ar: "إخفاء QR Code",
      en: "Hide QR Code",
    },
    showQR: {
      ar: "عرض QR Code للإيداع",
      en: "Show QR Code for Deposit",
    },
    scanQRHint: {
      ar: "امسح QR Code لنسخ عنوان المحفظة",
      en: "Scan QR Code to copy wallet address",
    },
    verifyAddressHint: {
      ar: "تأكد دائماً من مطابقة العنوان بعد المسح",
      en: "Always verify the address matches after scanning",
    },
    howToPayTitle: {
      ar: "كيفية الدفع:",
      en: "How to Pay:",
    },
    binancePayTitle: {
      ar: "كيفية الدفع عبر Binance Pay:",
      en: "How to Pay via Binance Pay:",
    },
    binancePayIdLabel: {
      ar: "Pay ID الخاص بنا",
      en: "Our Pay ID",
    },
    binancePayFaster: {
      ar: "أسرع طريقة دفع — بدون رسوم",
      en: "Fastest payment method — no fees",
    },
    copyPayId: {
      ar: "نسخ Pay ID",
      en: "Copy Pay ID",
    },
    payIdCopied: {
      ar: "✓ تم نسخ Pay ID",
      en: "✓ Pay ID copied",
    },
    noFees: {
      ar: "بدون رسوم",
      en: "No fees",
    },
    instant: {
      ar: "فوري",
      en: "Instant",
    },
    secure: {
      ar: "آمن 100%",
      en: "100% Secure",
    },
    transferNumber: {
      ar: "رقم التحويل",
      en: "Transfer Number",
    },
    copyNumberBtn: {
      ar: "نسخ الرقم",
      en: "Copy Number",
    },
    numberCopied: {
      ar: "✓ تم النسخ",
      en: "✓ Copied",
    },
    sendProofViaWebsite: {
      ar: "إرسال إثبات الدفع عبر الموقع",
      en: "Submit Payment Proof via Website",
    },
    autoProofSub: {
      ar: "تلقائي — يصلك كلمة السر فوراً بعد القبول",
      en: "Automatic — you get the password instantly after approval",
    },
    recommended: {
      ar: "موصى به",
      en: "Recommended",
    },
    sendProofViaTelegram: {
      ar: "إرسال إثبات الدفع على تيليجرام",
      en: "Send Payment Proof via Telegram",
    },
    manualTelegramSub: {
      ar: "يدوي — تواصل مع المدير مباشرة",
      en: "Manual — contact admin directly",
    },
    localPaymentSection: {
      ar: "وسائل الدفع المحلية",
      en: "Local Payment Methods",
    },
    binanceSection: {
      ar: "الدفع عبر Binance",
      en: "Pay via Binance",
    },
    globalBadge: {
      ar: "🌍 عالمي",
      en: "🌍 Global",
    },
    youAreBuying: {
      ar: "أنت تشتري:",
      en: "You are buying:",
    },
    selectPkgHint: {
      ar: "عند إرسال الإثبات ستُطلب منك اختيار الحزمة المراد الدفع لها",
      en: "When submitting proof you will be asked to select the package you are paying for",
    },
    paymentSubtitle: {
      ar: "اختر وسيلة الدفع وأرسل إثبات التحويل — عبر الموقع مباشرة أو عبر تيليجرام",
      en: "Choose a payment method and send your transfer proof — directly via the website or via Telegram",
    },
    telegramHandle: {
      ar: "تيليجرام:",
      en: "Telegram:",
    },
    afterPaymentNote: {
      ar: "بعد التحقق من الدفع سيتم إرسال كلمة السر الخاصة بالحزمة تلقائياً فوراً",
      en: "After payment verification the package password will be sent to you automatically and instantly",
    },
    pendingOperations: {
      ar: "عملياتي المعلقة",
      en: "My Pending Operations",
    },
    waitingStatus: {
      ar: "في الانتظار",
      en: "Waiting",
    },
    packageUnspecified: {
      ar: "حزمة غير محددة",
      en: "Unspecified Package",
    },
    // PackageSelectorModal
    choosePackageTitle: {
      ar: "اختر الحزمة التي تريد الدفع لها",
      en: "Choose the package you want to pay for",
    },
    searchPackagePlaceholder: {
      ar: "ابحث عن حزمة...",
      en: "Search for a package...",
    },
    loadingPackages: {
      ar: "جارِ تحميل الحزم...",
      en: "Loading packages...",
    },
    noMatchingPackages: {
      ar: "لا توجد حزم متطابقة",
      en: "No matching packages",
    },
    packageForPayment: {
      ar: "الحزمة المراد الدفع لها *",
      en: "Package to pay for *",
    },
    choosePackageBtn: {
      ar: "اضغط لاختيار الحزمة",
      en: "Click to choose package",
    },
    changeBtn: {
      ar: "تغيير",
      en: "Change",
    },
    packageLabel2: {
      ar: "الحزمة:",
      en: "Package:",
    },
    // UploadProofModal
    sendProofTitle: {
      ar: "إرسال إثبات الدفع",
      en: "Submit Payment Proof",
    },
    senderInfoCrypto: {
      ar: "عنوان محفظتك (للتحقق) أو معرّفك",
      en: "Your wallet address (for verification) or ID",
    },
    senderInfoBinancePay: {
      ar: "معرّف Binance Pay أو البريد الإلكتروني المرسِل",
      en: "Binance Pay ID or sender email",
    },
    senderInfoPhone: {
      ar: "رقم الهاتف الذي حولت منه",
      en: "The phone number you transferred from",
    },
    placeholderCrypto: {
      ar: "مثال: TXxxxxxxxxxxxxxx",
      en: "Example: TXxxxxxxxxxxxxxx",
    },
    placeholderBinancePay: {
      ar: "مثال: Binance Pay ID أو email@example.com",
      en: "Example: Binance Pay ID or email@example.com",
    },
    placeholderPhone: {
      ar: "مثال: 01012345678",
      en: "Example: 01012345678",
    },
    proofImageLabel: {
      ar: "صورة إثبات",
      en: "Proof image of",
    },
    proofImageCrypto: {
      ar: "المعاملة (Transaction Hash / سكرين)",
      en: "transaction (Transaction Hash / screenshot)",
    },
    proofImageTransfer: {
      ar: "التحويل",
      en: "the transfer",
    },
    dragOrClick: {
      ar: "اسحب الصورة هنا أو اضغط للاختيار",
      en: "Drag image here or click to choose",
    },
    imageHint: {
      ar: "PNG, JPG, WEBP — حد أقصى 10 ميجابايت",
      en: "PNG, JPG, WEBP — max 10 MB",
    },
    imageSelected: {
      ar: "تم اختيار الصورة",
      en: "Image selected",
    },
    trc20OnlyWarning: {
      ar: "⚠️ تأكد من استخدام شبكة TRC20 فقط — أي شبكة أخرى تُفقد الأموال نهائياً",
      en: "⚠️ Make sure to use TRC20 network only — any other network will permanently lose funds",
    },
    submittingProof: {
      ar: "جارِ الإرسال...",
      en: "Submitting...",
    },
    sendProofBtn: {
      ar: "إرسال الإثبات",
      en: "Submit Proof",
    },
    // Crypto steps
    cryptoStep1: {
      ar: "أرسل المبلغ بعملة USDT على شبكة TRC20 إلى العنوان المحدد",
      en: "Send the amount in USDT on TRC20 network to the specified address",
    },
    cryptoStep2: {
      ar: "تأكد من اختيار شبكة TRC20 (TRON) وإلا ستُفقد الأموال",
      en: "Make sure to select TRC20 (TRON) network or funds will be lost",
    },
    cryptoStep3: {
      ar: "انتظر تأكيد المعاملة على الشبكة",
      en: "Wait for transaction confirmation on the network",
    },
    cryptoStep4: {
      ar: "ارفع صورة إثبات التحويل (Hash أو سكرين)",
      en: "Upload the transfer proof image (Hash or screenshot)",
    },
    cryptoStep5: {
      ar: "ستصلك كلمة السر بعد تأكيد المدير ✓",
      en: "You will receive the password after admin confirmation ✓",
    },
    // BinancePay steps
    binancePayStep1: {
      ar: "افتح تطبيق Binance وانتقل إلى Binance Pay",
      en: "Open the Binance app and go to Binance Pay",
    },
    binancePayStep2: {
      ar: "ادفع إلى Pay ID: 956202789",
      en: "Pay to Pay ID: 956202789",
    },
    binancePayStep3: {
      ar: "أدخل المبلغ وأتمّ عملية الدفع",
      en: "Enter the amount and complete the payment",
    },
    binancePayStep4: {
      ar: "ارفع صورة إثبات عملية الدفع",
      en: "Upload the payment proof image",
    },
    binancePayStep5: {
      ar: "ستصلك كلمة السر بعد تأكيد المدير ✓",
      en: "You will receive the password after admin confirmation ✓",
    },
    // Phone steps template
    phoneStep1: {
      ar: "حوّل المبلغ على رقم",
      en: "Transfer the amount to the number",
    },
    phoneStep2: {
      ar: "أدخل رقمك الذي حولت منه",
      en: "Enter your number that you transferred from",
    },
    phoneStep3: {
      ar: "ارفع صورة إثبات التحويل",
      en: "Upload the transfer proof image",
    },
    phoneStep4: {
      ar: "انتظر تأكيد المدير وستصلك كلمة السر فوراً",
      en: "Wait for admin confirmation and you will receive the password instantly",
    },
    // ProofSuccessScreen
    proofSuccessTitle: {
      ar: "عملية دفع معلقة",
      en: "Payment Pending",
    },
    proofSuccessDesc: {
      ar: "تم إرسال إثبات الدفع بنجاح! سيتحقق المدير من الإثبات وسيتم إرسال كلمة سر الحزمة إليك خلال دقائق قليلة.",
      en: "Payment proof submitted successfully! The admin will verify it and send you the package password within a few minutes.",
    },
    adminVerifying: {
      ar: "يتحقق المدير من الإثبات",
      en: "Admin is verifying the proof",
    },
    passwordSentAuto: {
      ar: "تصلك كلمة سر الحزمة تلقائياً",
      en: "Package password will be sent to you automatically",
    },
    expectedWait: {
      ar: "وقت الانتظار المتوقع: 5 - 15 دقيقة",
      en: "Expected wait time: 5 - 15 minutes",
    },
    okWillWait: {
      ar: "حسناً، سأنتظر",
      en: "OK, I'll wait",
    },
    // Error messages
    errorFileType: {
      ar: "الملف يجب أن يكون صورة",
      en: "The file must be an image",
    },
    errorFileSize: {
      ar: "حجم الصورة يجب أن يكون أقل من 10 ميجابايت",
      en: "Image size must be less than 10 MB",
    },
    errorUploadFailed: {
      ar: "فشل رفع الصورة",
      en: "Failed to upload image",
    },
    errorSendFailed: {
      ar: "حدث خطأ أثناء الإرسال، يرجى المحاولة مرة أخرى",
      en: "An error occurred during submission, please try again",
    },
    errorShortInfo: {
      ar: "المعلومات المدخلة غير صحيحة أو قصيرة جداً",
      en: "The entered information is incorrect or too short",
    },
    errorNoImage: {
      ar: "يرجى رفع صورة إثبات الدفع",
      en: "Please upload a payment proof image",
    },
    // MyOrdersBanner (inline in Payment)
    myOrdersTitle: {
      ar: "طلباتي",
      en: "My Orders",
    },
    myOrderPending: {
      ar: "معلق",
      en: "Pending",
    },
    myOrderApproved: {
      ar: "مقبول",
      en: "Approved",
    },
    myOrderRejected: {
      ar: "مرفوض",
      en: "Rejected",
    },
    passwordLabel: {
      ar: "كلمة السر: ",
      en: "Password: ",
    },
    rejectedProofInline: {
      ar: "تم رفض الإثبات — تواصل مع المدير",
      en: "Proof was rejected — contact admin",
    },
  },

  // ──────────────────────────── MY ORDERS SIDEBAR ──────────────────────────────
  orders: {
    title: {
      ar: "طلباتي",
      en: "My Orders",
    },
    noOrders: {
      ar: "لا توجد طلبات بعد",
      en: "No orders yet",
    },
    noOrdersDesc: {
      ar: "بعد إرسال إثبات الدفع، ستظهر طلباتك هنا",
      en: "After submitting payment proof, your orders will appear here",
    },
    pending: {
      ar: "معلق",
      en: "Pending",
    },
    approved: {
      ar: "مقبول",
      en: "Approved",
    },
    rejected: {
      ar: "مرفوض",
      en: "Rejected",
    },
    password: {
      ar: "كلمة السر",
      en: "Password",
    },
    copyPassword: {
      ar: "نسخ",
      en: "Copy",
    },
    copied: {
      ar: "تم!",
      en: "Done!",
    },
    orderId: {
      ar: "رقم الطلب",
      en: "Order ID",
    },
    method: {
      ar: "طريقة الدفع",
      en: "Payment Method",
    },
    goToPayment: {
      ar: "الدفع الآن",
      en: "Pay Now",
    },
    refreshing: {
      ar: "جارِ التحديث...",
      en: "Refreshing...",
    },
    waitingApproval: {
      ar: "في انتظار الموافقة",
      en: "Awaiting Approval",
    },
    rejectedNote: {
      ar: "تواصل مع الدعم",
      en: "Contact Support",
    },
    // MyOrdersSidebar specific
    pendingStatusLabel: {
      ar: "معلق",
      en: "Pending",
    },
    approvedStatusLabel: {
      ar: "مقبول",
      en: "Approved",
    },
    rejectedStatusLabel: {
      ar: "مرفوض",
      en: "Rejected",
    },
    packageUnspecified: {
      ar: "حزمة غير محددة",
      en: "Unspecified Package",
    },
    reviewingProof: {
      ar: "جارِ مراجعة إثباتك من قِبل المدير...",
      en: "Your proof is being reviewed by the admin...",
    },
    packagePasswordLabel: {
      ar: "كلمة سر الحزمة",
      en: "Package Password",
    },
    copyPasswordBtn: {
      ar: "نسخ كلمة السر",
      en: "Copy Password",
    },
    passwordCopied: {
      ar: "تم النسخ!",
      en: "Copied!",
    },
    rejectedProofNote: {
      ar: "تم رفض إثبات الدفع — تواصل مع المدير عبر تيليجرام",
      en: "Payment proof was rejected — contact admin via Telegram",
    },
    loadingOrders: {
      ar: "جارِ تحميل الطلبات...",
      en: "Loading orders...",
    },
    emptyOrdersDesc: {
      ar: "عند إرسال إثبات دفع سيظهر هنا طلبك ويمكنك متابعة حالته",
      en: "After submitting a payment proof your order will appear here and you can track its status",
    },
    emptyFilterDesc: {
      ar: "لا توجد طلبات في هذه الفئة",
      en: "No orders in this category",
    },
    submitNewProof: {
      ar: "إرسال إثبات دفع جديد",
      en: "Submit New Payment Proof",
    },
  },

  // ──────────────────────────── SUPPORT PAGE ───────────────────────────────────
  support: {
    title: {
      ar: "الدعم الفني",
      en: "Technical Support",
    },
    subtitle: {
      ar: "نحن هنا لمساعدتك! تواصل معنا عبر القنوات التالية",
      en: "We are here to help! Contact us through the following channels",
    },
    back: {
      ar: "الرئيسية",
      en: "Home",
    },
    howItWorksTitle: {
      ar: "كيف يعمل الموقع؟",
      en: "How Does the Site Work?",
    },
    freePackagesTitle: {
      ar: "باقات تخطي الروابط (مجانية)",
      en: "Link Bypass Packages (Free)",
    },
    freeStep1: {
      ar: 'اضغط على الباقة المميزة بـ "تخطي روابط"',
      en: 'Click on the package marked "Link Bypass"',
    },
    freeStep2: {
      ar: 'اضغط "اضغط هنا للمتابعة" في الصفحة الأولى',
      en: 'Click "Click here to continue" on the first page',
    },
    freeStep3: {
      ar: "انتظر اكتمال شريط التحميل في الصفحة الثانية",
      en: "Wait for the loading bar to complete on the second page",
    },
    freeStep4: {
      ar: "انتظر العداد (15 ثانية) في الصفحة الثالثة",
      en: "Wait for the countdown (15 seconds) on the third page",
    },
    freeStep5: {
      ar: 'يظهر الرابط — اضغط "فتح رابط الميجا" أو انسخه',
      en: 'The link appears — click "Open MEGA Link" or copy it',
    },
    freeNote: {
      ar: "💡 هذه الباقات مجانية تماماً — الموقع يربح من الإعلانات",
      en: "💡 These packages are completely free — the site earns from ads",
    },
    paidPackagesTitle: {
      ar: "الباقات المدفوعة",
      en: "Paid Packages",
    },
    paidStep1: {
      ar: 'اضغط على الباقة أو زر "شراء الحزمة"',
      en: 'Click on the package or "Buy Package" button',
    },
    paidStep2: {
      ar: "ادفع المبلغ المطلوب بأي طريقة دفع متاحة",
      en: "Pay the required amount using any available payment method",
    },
    paidStep3: {
      ar: "ارفع صورة إثبات الدفع في نموذج الدفع",
      en: "Upload a payment proof image in the payment form",
    },
    paidStep4: {
      ar: "انتظر التحقق من الدفع (حتى 24 ساعة)",
      en: "Wait for payment verification (up to 24 hours)",
    },
    paidStep5: {
      ar: "ستصلك كلمة السر — أدخلها في نافذة الباقة",
      en: "You will receive the password — enter it in the package window",
    },
    paidNote: {
      ar: "💳 طرق الدفع: Binance USDT (TRC20)، Binance Pay",
      en: "💳 Payment methods: Binance USDT (TRC20), Binance Pay",
    },
    faqTitle: {
      ar: "الأسئلة الشائعة",
      en: "Frequently Asked Questions",
    },
    faq1Q: {
      ar: "ما الفرق بين الباقات المجانية والمدفوعة؟",
      en: "What is the difference between free and paid packages?",
    },
    faq1A: {
      ar: "الباقات المجانية (تخطي الروابط) تتيح لك الوصول للرابط مجاناً عبر المرور بـ 5 صفحات تحتوي على إعلانات. الباقات المدفوعة تتطلب شراء كلمة سر وصول.",
      en: "Free packages (link bypass) allow you to access the link for free by passing through 5 pages with ads. Paid packages require purchasing an access password.",
    },
    faq2Q: {
      ar: "لماذا توجد إعلانات في صفحات التخطي؟",
      en: "Why are there ads on bypass pages?",
    },
    faq2A: {
      ar: "الإعلانات هي الطريقة التي يعتمدها الموقع لتقديم الباقات المجانية. عند مشاهدة الإعلانات، تساعد في تمويل الموقع مقابل حصولك على الرابط مجاناً.",
      en: "Ads are how the site funds free packages. By viewing ads, you help finance the site in exchange for getting the link for free.",
    },
    faq3Q: {
      ar: "كم من الوقت تستغرق صفحات التخطي؟",
      en: "How long do bypass pages take?",
    },
    faq3A: {
      ar: "الصفحة الأولى: فورية. الصفحة الثانية: ~8 ثوانٍ (شريط تحميل). الصفحة الثالثة: 15 ثانية (عداد). الإجمالي: حوالي 25 ثانية.",
      en: "First page: instant. Second page: ~8 seconds (loading bar). Third page: 15 seconds (countdown). Total: about 25 seconds.",
    },
    faq4Q: {
      ar: "لم يعمل الرابط، ماذا أفعل؟",
      en: "The link didn't work, what should I do?",
    },
    faq4A: {
      ar: "إذا كانت مشكلة مع رابط الميجا، تواصل مع الدعم عبر تيليجرام @Ab7mega778 مع ذكر اسم الباقة.",
      en: "If there's a problem with the MEGA link, contact support via Telegram @Ab7mega778 and mention the package name.",
    },
    faq5Q: {
      ar: "متى أحصل على كلمة السر بعد الدفع؟",
      en: "When do I get the password after payment?",
    },
    faq5A: {
      ar: "عادةً خلال 1-24 ساعة بعد التحقق من إثبات الدفع. للاستعجال تواصل عبر تيليجرام.",
      en: "Usually within 1-24 hours after payment proof verification. For urgency, contact via Telegram.",
    },
    telegramTitle: {
      ar: "تواصل عبر تيليجرام",
      en: "Contact via Telegram",
    },
    telegramDesc: {
      ar: "تواصل سريع ومباشر مع فريق الدعم عبر تيليجرام",
      en: "Quick and direct communication with the support team via Telegram",
    },
    telegramBtn: {
      ar: "فتح تيليجرام",
      en: "Open Telegram",
    },
    emailTitle: {
      ar: "تواصل عبر البريد الإلكتروني",
      en: "Contact via Email",
    },
    emailDesc: {
      ar: "أرسل لنا رسالة مفصلة عبر البريد الإلكتروني",
      en: "Send us a detailed message via email",
    },
    emailBtn: {
      ar: "إرسال بريد إلكتروني",
      en: "Send Email",
    },
    responseTitle: {
      ar: "وقت الاستجابة السريع",
      en: "Fast Response Time",
    },
    responseDesc: {
      ar: "نحن نرد على جميع الاستفسارات خلال 24 ساعة",
      en: "We respond to all inquiries within 24 hours",
    },
  },

  // ─────────────────────────── SPECIAL REQUEST ─────────────────────────────────
  specialRequest: {
    title: {
      ar: "الطلبات الخاصة",
      en: "Special Requests",
    },
    subtitle: {
      ar: "احصل على حزمة مخصصة حسب رغبتك",
      en: "Get a custom package tailored to your wishes",
    },
    back: {
      ar: "الرئيسية",
      en: "Home",
    },
    feature1Title: {
      ar: "حزم مخصصة",
      en: "Custom Packages",
    },
    feature1Desc: {
      ar: "اطلب حزمة خاصة لممثلة معينة أو محتوى محدد",
      en: "Request a special package for a specific performer or content",
    },
    feature2Title: {
      ar: "أسعار مرنة",
      en: "Flexible Pricing",
    },
    feature2Desc: {
      ar: "نقدم أسعاراً تنافسية تناسب جميع الميزانيات",
      en: "We offer competitive prices to suit all budgets",
    },
    feature3Title: {
      ar: "تسليم سريع",
      en: "Fast Delivery",
    },
    feature3Desc: {
      ar: "نسعى لتسليم طلباتك في أقصر وقت ممكن",
      en: "We strive to deliver your requests as quickly as possible",
    },
    howTitle: {
      ar: "كيف تطلب؟",
      en: "How to Request?",
    },
    step1: {
      ar: "تواصل معنا عبر تيليجرام",
      en: "Contact us via Telegram",
    },
    step2: {
      ar: "أخبرنا بالمحتوى المطلوب",
      en: "Tell us what content you need",
    },
    step3: {
      ar: "احصل على عرض السعر",
      en: "Get a price quote",
    },
    step4: {
      ar: "استلم حزمتك الخاصة",
      en: "Receive your custom package",
    },
    telegramBtn: {
      ar: "تواصل عبر تيليجرام",
      en: "Contact via Telegram",
    },
    noteTitle: {
      ar: "ملاحظة مهمة",
      en: "Important Note",
    },
    noteDesc: {
      ar: "الطلبات الخاصة قد تستغرق وقتاً أطول حسب توفر المحتوى المطلوب",
      en: "Special requests may take longer depending on the availability of the requested content",
    },
  },

  // ────────────────────────── VAST AD PLAYER ───────────────────────────────────
  vastAd: {
    loading: {
      ar: "جاري تحميل الإعلان...",
      en: "Loading ad...",
    },
    clickForMore: {
      ar: "اضغط للمزيد من المعلومات ↗",
      en: "Click for more information ↗",
    },
    adBadge: {
      ar: "إعلان",
      en: "Ad",
    },
    preRoll: {
      ar: "إعلان قبل الفيديو",
      en: "Pre-roll Ad",
    },
    midRoll: {
      ar: "إعلان في المنتصف",
      en: "Mid-roll Ad",
    },
    muteUnmute: {
      ar: "كتم / رفع الصوت",
      en: "Mute / Unmute",
    },
    skipAfter: {
      ar: "تخطي بعد {seconds}ث",
      en: "Skip in {seconds}s",
    },
    skipAd: {
      ar: "تخطي الإعلان",
      en: "Skip Ad",
    },
    secondsAbbr: {
      ar: "ث",
      en: "s",
    },
  },

  // ────────────────────────── EDUCATIONAL VIDEO ────────────────────────────────
  educational: {
    title: {
      ar: "كيفية تخطي الروابط",
      en: "How to Bypass Links",
    },
    subtitle: {
      ar: "دليل خطوة بخطوة لتخطي روابط الحزم المجانية",
      en: "A step-by-step guide to bypassing free package links",
    },
    back: {
      ar: "الرئيسية",
      en: "Home",
    },
    step1Title: {
      ar: "افتح الرابط",
      en: "Open the Link",
    },
    step1Desc: {
      ar: "اضغط على زر 'الحصول على الرابط' في صفحة الحزمة المجانية",
      en: "Click the 'Get the Link' button on the free package page",
    },
    step2Title: {
      ar: "انتظر العد التنازلي",
      en: "Wait for Countdown",
    },
    step2Desc: {
      ar: "انتظر حتى ينتهي العد التنازلي ثم اضغط على الزر الظاهر",
      en: "Wait for the countdown to finish then click the visible button",
    },
    step3Title: {
      ar: "تخطَّ الإعلانات",
      en: "Skip the Ads",
    },
    step3Desc: {
      ar: "اتبع التعليمات الظاهرة لتخطي صفحات الإعلانات بخطوات بسيطة",
      en: "Follow the on-screen instructions to skip ad pages in simple steps",
    },
    step4Title: {
      ar: "احصل على الرابط",
      en: "Get the Link",
    },
    step4Desc: {
      ar: "بعد اكتمال الخطوات ستصل إلى رابط اونلي فانز الحصري مباشرةً",
      en: "After completing the steps you will reach the exclusive OnlyFans link directly",
    },
    videoTitle: {
      ar: "فيديو تعليمي",
      en: "Tutorial Video",
    },
    watchVideo: {
      ar: "شاهد الفيديو",
      en: "Watch Video",
    },
    tips: {
      ar: "نصائح مفيدة",
      en: "Useful Tips",
    },
    tip1: {
      ar: "استخدم متصفح Chrome أو Firefox للحصول على أفضل تجربة",
      en: "Use Chrome or Firefox for the best experience",
    },
    tip2: {
      ar: "لا تغلق الصفحة أثناء عملية التخطي",
      en: "Don't close the page during the bypass process",
    },
    tip3: {
      ar: "إذا واجهت مشكلة، تواصل مع الدعم",
      en: "If you have a problem, contact support",
    },
    contactSupport: {
      ar: "تواصل مع الدعم",
      en: "Contact Support",
    },
    telegramChannelLabel: {
      ar: "قناتنا على تيليجرام",
      en: "Our Telegram Channel",
    },
    telegramChannelSub: {
      ar: "انضم لقناتنا على تيليجرام للحصول على آخر التحديثات والعروض",
      en: "Join our Telegram channel for the latest updates and offers",
    },
    telegramChannelBtn: {
      ar: "انضم للقناة",
      en: "Join Channel",
    },
    infoCardTitle: {
      ar: "ملاحظة مهمة",
      en: "Important Note",
    },
  },

  // ────────────────────────── BYPASS PAGES ─────────────────────────────────────
  bypass: {
    adLabel: {
      ar: "إعلان",
      en: "Ad",
    },
    exclusiveOffers: {
      ar: "🎁 عروض حصرية — اضغط هنا",
      en: "🎁 Exclusive Offers — Click Here",
    },
    promoTitle: {
      ar: "🔥 عروض حصرية لأعضاء Leaks Mercy",
      en: "🔥 Exclusive Offers for Leaks Mercy Members",
    },
    promoSub: {
      ar: "اكتشف أفضل العروض الحصرية المتاحة الآن",
      en: "Discover the best exclusive deals available now",
    },
    promoBtn: {
      ar: "اكتشف العروض ←",
      en: "Explore Offers →",
    },
    privacyPolicy: {
      ar: "سياسة الخصوصية",
      en: "Privacy Policy",
    },
    termsOfService: {
      ar: "شروط الاستخدام",
      en: "Terms of Service",
    },
    footer: {
      ar: "© 2025 Leaks Mercy — جميع الحقوق محفوظة",
      en: "© 2025 Leaks Mercy — All Rights Reserved",
    },
    ageFooter: {
      ar: "+18 فقط",
      en: "+18 Only",
    },
    brand: {
      ar: "Leaks Mercy",
      en: "Leaks Mercy",
    },
    // WaitingPage
    waitingTitle: {
      ar: "عرض رابط الحزمة",
      en: "View Package Link",
    },
    waitingDesc: {
      ar: "للوصول إلى رابط الميجا الخاص بهذه الحزمة مجاناً، اضغط على الزر أدناه للمتابعة",
      en: "To access the MEGA link for this package for free, press the button below to continue",
    },
    waitingBtn: {
      ar: "اضغط هنا للمتابعة",
      en: "Click Here to Continue",
    },
    freeNote: {
      ar: "الرابط مجاني تماماً — لا حاجة للدفع",
      en: "The link is completely free — no payment required",
    },
    // DownloadPage
    downloadTitle: {
      ar: "جارِ تجهيز الرابط",
      en: "Preparing the Link",
    },
    downloadReady: {
      ar: "الرابط جاهز! ✓",
      en: "Link Ready! ✓",
    },
    downloadBtn: {
      ar: "اضغط هنا للانتقال للخطوة التالية",
      en: "Click Here to Go to the Next Step",
    },
    loadStep1: {
      ar: "الاتصال بالخوادم",
      en: "Connecting to servers",
    },
    loadStep2: {
      ar: "تجهيز الرابط",
      en: "Preparing the link",
    },
    loadStep3: {
      ar: "التحقق من الحزمة",
      en: "Verifying the package",
    },
    loadStep4: {
      ar: "الرابط جاهز",
      en: "Link ready",
    },
    connectingServers: {
      ar: "جارِ الاتصال بالخوادم...",
      en: "Connecting to servers...",
    },
    preparingLink: {
      ar: "جارِ تجهيز الرابط...",
      en: "Preparing the link...",
    },
    verifyingPackage: {
      ar: "جارِ التحقق من الحزمة...",
      en: "Verifying the package...",
    },
    operationComplete: {
      ar: "اكتملت العملية...",
      en: "Operation complete...",
    },
    linkReady: {
      ar: "الرابط جاهز!",
      en: "Link ready!",
    },
    clickNextStep: {
      ar: "اضغط على الزر أدناه للانتقال إلى الخطوة التالية",
      en: "Press the button below to go to the next step",
    },
    // VerifyPage
    verifyTitle: {
      ar: "جارِ التحقق الأمني",
      en: "Security Verification in Progress",
    },
    verifyDesc: {
      ar: "نتحقق من صحة طلبك للحصول على الرابط، يرجى الانتظار لحظة...",
      en: "Verifying your request to get the link, please wait a moment...",
    },
    verifyDone: {
      ar: "التحقق مكتمل ✓",
      en: "Verification Complete ✓",
    },
    verifyDoneDesc: {
      ar: "تم التحقق من هويتك بنجاح! اضغط للمتابعة للخطوة التالية",
      en: "Your identity has been verified successfully! Press to proceed to the next step",
    },
    verifyNextBtn: {
      ar: "متابعة للخطوة التالية",
      en: "Proceed to Next Step",
    },
    secureNote: {
      ar: "العملية آمنة وفقاً لمعايير SSL",
      en: "The process is secure according to SSL standards",
    },
    checkUser: {
      ar: "التحقق من هوية المستخدم",
      en: "Verifying user identity",
    },
    checkConnection: {
      ar: "فحص أمان الاتصال",
      en: "Checking connection security",
    },
    checkRequest: {
      ar: "التحقق من صحة طلب الرابط",
      en: "Validating link request",
    },
    // RewardPage
    rewardTitle: {
      ar: "أنت على وشك الحصول على الرابط!",
      en: "You're About to Get the Link!",
    },
    rewardDesc: {
      ar: "خطوة واحدة أخيرة فقط! انتظر {seconds} ثانية ثم اضغط للوصول إلى الرابط",
      en: "Just one last step! Wait {seconds} seconds then press to access the link",
    },
    rewardReady: {
      ar: "🎉 المكافأة جاهزة!",
      en: "🎉 Reward Ready!",
    },
    rewardReadyDesc: {
      ar: "تهانينا! رابط الميجا جاهز لك الآن",
      en: "Congratulations! The MEGA link is ready for you now",
    },
    rewardBtn: {
      ar: "فتح رابط الميجا الآن",
      en: "Open MEGA Link Now",
    },
    preparingReward: {
      ar: "جارِ تحضير المكافأة...",
      en: "Preparing reward...",
    },
    // LinkequipPage
    linkTitle: {
      ar: "رابط الميجا جاهز! 🔥",
      en: "MEGA Link Ready! 🔥",
    },
    linkDesc: {
      ar: "إليك رابط الميجا الحصري",
      en: "Here is your exclusive MEGA link",
    },
    openMega: {
      ar: "فتح رابط الميجا",
      en: "Open MEGA Link",
    },
    copyLink: {
      ar: "نسخ الرابط",
      en: "Copy Link",
    },
    linkCopied: {
      ar: "تم نسخ الرابط! ✓",
      en: "Link copied! ✓",
    },
    backHome: {
      ar: "العودة للرئيسية",
      en: "Back to Home",
    },
    securityReminder: {
      ar: "تذكير: لا تشارك هذا الرابط مع الآخرين",
      en: "Reminder: Do not share this link with others",
    },
  },

  // ──────────────────────── CURRENCY CONVERTER ─────────────────────────────────
  currency: {
    title: {
      ar: "محوّل العملات",
      en: "Currency Converter",
    },
    from: {
      ar: "من",
      en: "From",
    },
    to: {
      ar: "إلى",
      en: "To",
    },
    amount: {
      ar: "المبلغ",
      en: "Amount",
    },
    result: {
      ar: "النتيجة",
      en: "Result",
    },
    convert: {
      ar: "تحويل",
      en: "Convert",
    },
    loading: {
      ar: "جارِ التحميل...",
      en: "Loading...",
    },
    error: {
      ar: "خطأ في تحميل الأسعار",
      en: "Error loading rates",
    },
    lastUpdated: {
      ar: "آخر تحديث",
      en: "Last updated",
    },
    search: {
      ar: "ابحث عن عملة...",
      en: "Search currency...",
    },
    swap: {
      ar: "تبديل",
      en: "Swap",
    },
    rateInfo: {
      ar: "معدل الصرف",
      en: "Exchange Rate",
    },
    close: {
      ar: "إغلاق",
      en: "Close",
    },
  },

  // ──────────────────────────── AD BLOCK DETECTOR ──────────────────────────────
  adblock: {
    title: {
      ar: "تم اكتشاف مانع الإعلانات",
      en: "Ad Blocker Detected",
    },
    desc: {
      ar: "يبدو أنك تستخدم مانع إعلانات. هذا الموقع يعتمد على الإعلانات لتقديم المحتوى المجاني. يرجى تعطيل مانع الإعلانات للمتابعة.",
      en: "It looks like you're using an ad blocker. This site relies on ads to provide free content. Please disable your ad blocker to continue.",
    },
    btn: {
      ar: "تعطيلت مانع الإعلانات وتحديث الصفحة",
      en: "Disable Ad Blocker & Refresh",
    },
  },

  // ─────────────────────────── PASSWORD SIDEBAR ────────────────────────────────
  passwordSidebar: {
    title: {
      ar: "كلمات السر",
      en: "Passwords",
    },
  },

  // ─────────────────────────── SUPPORT US PAGE ────────────────────────────────
  supportus: {
    pageTitle: {
      ar: "ادعمنا",
      en: "Support Us",
    },
    pageSubtitle: {
      ar: "ساعدنا على الاستمرار والنمو — كل دعم يُحدث فرقاً حقيقياً",
      en: "Help us keep growing — every bit of support makes a real difference",
    },
    back: {
      ar: "الرئيسية",
      en: "Home",
    },
    heroBadge: {
      ar: "💛 ادعم Leaks Mercy",
      en: "💛 Support Leaks Mercy",
    },
    heroTitle: {
      ar: "Leaks Mercy يحتاج دعمك",
      en: "Leaks Mercy Needs Your Support",
    },
    heroDesc: {
      ar: "نحن فريق صغير يعمل بجد لتقديم أفضل محتوى حصري مجاناً أو بأسعار في متناول الجميع. دعمك يساعدنا على تحسين الخدمة، إضافة محتوى جديد، والاستمرار في النمو.",
      en: "We are a small team working hard to deliver the best exclusive content for free or at affordable prices. Your support helps us improve the service, add new content, and keep growing.",
    },
    // Stats
    stat1Value: {
      ar: "100%",
      en: "100%",
    },
    stat1Label: {
      ar: "محتوى حصري",
      en: "Exclusive Content",
    },
    stat2Value: {
      ar: "مجاني",
      en: "Free",
    },
    stat2Label: {
      ar: "أساس الخدمة",
      en: "Service Core",
    },
    stat3Value: {
      ar: "نمو",
      en: "Growth",
    },
    stat3Label: {
      ar: "مستمر",
      en: "Ongoing",
    },
    // Section headers
    financialSupportTitle: {
      ar: "💰 الدعم المادي",
      en: "💰 Financial Support",
    },
    financialSupportSubtitle: {
      ar: "ادعمنا مالياً عبر Binance — آمن، سريع، وبدون رسوم",
      en: "Support us financially via Binance — secure, fast, and fee-free",
    },
    spreadWordTitle: {
      ar: "📢 انشر الموقع",
      en: "📢 Spread the Site",
    },
    spreadWordSubtitle: {
      ar: "شارك الموقع مع أصدقائك وساعدنا على الانتشار",
      en: "Share the site with your friends and help us grow",
    },
    // Financial support - Binance USDT card
    binanceUsdtTitle: {
      ar: "Binance USDT",
      en: "Binance USDT",
    },
    binanceUsdtDesc: {
      ar: "أرسل أي مبلغ تريده عبر شبكة TRC20",
      en: "Send any amount you want via TRC20 network",
    },
    binanceUsdtNetwork: {
      ar: "الشبكة: TRC20 (TRX)",
      en: "Network: TRC20 (TRX)",
    },
    binanceUsdtWarning: {
      ar: "⚠️ استخدم شبكة TRC20 فقط — أي شبكة أخرى تُفقد الأموال نهائياً",
      en: "⚠️ Use TRC20 network only — any other network will permanently lose funds",
    },
    walletAddress: {
      ar: "عنوان المحفظة",
      en: "Wallet Address",
    },
    copyAddress: {
      ar: "نسخ العنوان",
      en: "Copy Address",
    },
    addressCopied: {
      ar: "✓ تم نسخ العنوان",
      en: "✓ Address copied",
    },
    showQR: {
      ar: "عرض QR Code",
      en: "Show QR Code",
    },
    hideQR: {
      ar: "إخفاء QR Code",
      en: "Hide QR Code",
    },
    scanQR: {
      ar: "امسح للإيداع",
      en: "Scan to Deposit",
    },
    // Financial support - Binance Pay card
    binancePayTitle: {
      ar: "Binance Pay",
      en: "Binance Pay",
    },
    binancePayDesc: {
      ar: "الأسرع والأسهل — بدون رسوم، بدون شبكات",
      en: "Fastest and easiest — no fees, no networks",
    },
    payId: {
      ar: "Pay ID الخاص بنا",
      en: "Our Pay ID",
    },
    copyPayId: {
      ar: "نسخ Pay ID",
      en: "Copy Pay ID",
    },
    payIdCopied: {
      ar: "✓ تم نسخ Pay ID",
      en: "✓ Pay ID copied",
    },
    binancePaySteps: {
      ar: "افتح Binance ← Binance Pay ← أدخل الـ Pay ID ← أرسل أي مبلغ",
      en: "Open Binance ← Binance Pay ← Enter Pay ID ← Send any amount",
    },
    // Steps guide for USDT card in support page
    usdtStep1: {
      ar: "افتح تطبيق Binance وانتقل إلى قسم Crypto",
      en: "Open the Binance app and go to the Crypto section",
    },
    usdtStep2: {
      ar: "اضغط على Send وابحث عن USDT",
      en: "Tap Send and search for USDT",
    },
    usdtStep3: {
      ar: "أدخل العنوان أعلاه وتأكد من اختيار شبكة TRC20",
      en: "Enter the address above and make sure to select TRC20 network",
    },
    usdtStep4: {
      ar: "أدخل المبلغ الذي تريد إرساله وأتمّ العملية",
      en: "Enter the amount you want to send and complete the transaction",
    },
    usdtStep5: {
      ar: "يصلنا التبرع فوراً — شكراً لدعمك! ❤️",
      en: "We receive your donation instantly — thank you for your support! ❤️",
    },
    // Steps guide for Binance Pay card in support page
    binancePaySupportStep1: {
      ar: "افتح تطبيق Binance وانتقل إلى Binance Pay",
      en: "Open the Binance app and go to Binance Pay",
    },
    binancePaySupportStep2: {
      ar: "اضغط على Send وأدخل الـ Pay ID: 956202789",
      en: "Tap Send and enter Pay ID: 956202789",
    },
    binancePaySupportStep3: {
      ar: "اختر العملة والمبلغ الذي تريد إرساله",
      en: "Choose the currency and the amount you want to send",
    },
    binancePaySupportStep4: {
      ar: "أتمّ عملية الدفع ويصلنا التبرع فوراً ❤️",
      en: "Complete the payment and we receive your donation instantly ❤️",
    },
    stepsGuideTitle: {
      ar: "كيفية الدعم:",
      en: "How to Support:",
    },
    // Spread the word section
    siteLink: {
      ar: "رابط الموقع",
      en: "Site Link",
    },
    copyLink: {
      ar: "نسخ الرابط",
      en: "Copy Link",
    },
    linkCopied: {
      ar: "✓ تم نسخ الرابط",
      en: "✓ Link copied",
    },
    spreadDesc: {
      ar: "شارك رابط الموقع مع أصدقائك ومعارفك على وسائل التواصل الاجتماعي. كل زيارة جديدة تساعدنا على تحسين المحتوى والاستمرار في النمو.",
      en: "Share the site link with your friends and acquaintances on social media. Every new visit helps us improve the content and keep growing.",
    },
    shareOnWhatsApp: {
      ar: "شارك على WhatsApp",
      en: "Share on WhatsApp",
    },
    shareOnTelegram: {
      ar: "شارك على Telegram",
      en: "Share on Telegram",
    },
    shareOnX: {
      ar: "شارك على X",
      en: "Share on X",
    },
    whatsappMsg: {
      ar: "شاهد هذا الموقع الرائع! محتوى حصري ومجاني: https://leaksmercy.site",
      en: "Check out this amazing site! Exclusive and free content: https://leaksmercy.site",
    },
    telegramMsg: {
      ar: "شاهد هذا الموقع الرائع! محتوى حصري ومجاني: https://leaksmercy.site",
      en: "Check out this amazing site! Exclusive and free content: https://leaksmercy.site",
    },
    xMsg: {
      ar: "شاهد هذا الموقع الرائع! محتوى حصري: https://leaksmercy.site",
      en: "Check out this amazing site! Exclusive content: https://leaksmercy.site",
    },
    // Why support section
    whySupportTitle: {
      ar: "لماذا دعمنا مهم؟",
      en: "Why Is Your Support Important?",
    },
    reason1Title: {
      ar: "محتوى أكثر وأفضل",
      en: "More & Better Content",
    },
    reason1Desc: {
      ar: "دعمك يمكّننا من إضافة المزيد من الحزم الحصرية وتحسين جودة المحتوى باستمرار",
      en: "Your support enables us to add more exclusive packages and continuously improve content quality",
    },
    reason2Title: {
      ar: "استمرارية الخدمة",
      en: "Service Continuity",
    },
    reason2Desc: {
      ar: "تشغيل الموقع يتطلب تكاليف — دعمك يضمن استمرار تقديم الخدمة مجاناً للجميع",
      en: "Running the site has costs — your support ensures we keep delivering the service free for everyone",
    },
    reason3Title: {
      ar: "نمو وتطوير",
      en: "Growth & Development",
    },
    reason3Desc: {
      ar: "نطمح لتطوير ميزات جديدة وتحسين تجربة المستخدم — وذلك يحتاج إلى دعمك",
      en: "We aspire to develop new features and improve user experience — and that needs your support",
    },
    // Features badges
    featureNoFees: {
      ar: "بدون رسوم",
      en: "No Fees",
    },
    featureInstant: {
      ar: "فوري",
      en: "Instant",
    },
    featureSecure: {
      ar: "آمن 100%",
      en: "100% Secure",
    },
    featureAnyAmount: {
      ar: "أي مبلغ",
      en: "Any Amount",
    },
    // Thank you section
    thankYouTitle: {
      ar: "شكراً لك ❤️",
      en: "Thank You ❤️",
    },
    thankYouDesc: {
      ar: "كل دعم، مهما كان صغيراً، يُحدث فرقاً حقيقياً ويشجعنا على الاستمرار. نحن نقدّر ثقتك بنا.",
      en: "Every bit of support, no matter how small, makes a real difference and encourages us to keep going. We appreciate your trust in us.",
    },
  },

  // ─────────────────────────── EMAIL VERIFY PAGE ──────────────────────────────
  emailVerify: {
    // States
    loadingTitle: {
      ar: "جارِ التحقق...",
      en: "Verifying...",
    },
    loadingDesc: {
      ar: "يرجى الانتظار بينما نتحقق من بريدك الإلكتروني",
      en: "Please wait while we verify your email address",
    },
    successTitle: {
      ar: "تم التحقق بنجاح! ✓",
      en: "Verified Successfully! ✓",
    },
    successDesc: {
      ar: "تم التحقق من بريدك الإلكتروني بنجاح. يمكنك الآن تسجيل الدخول والاستمتاع بجميع مزايا الموقع.",
      en: "Your email address has been successfully verified. You can now sign in and enjoy all the site's features.",
    },
    expiredTitle: {
      ar: "انتهت صلاحية الرابط",
      en: "Link Expired",
    },
    expiredDesc: {
      ar: "انتهت صلاحية رابط التحقق. يرجى طلب رابط تحقق جديد.",
      en: "The verification link has expired. Please request a new verification link.",
    },
    invalidTitle: {
      ar: "رابط غير صالح",
      en: "Invalid Link",
    },
    invalidDesc: {
      ar: "رابط التحقق غير صالح أو تالف. يرجى التحقق من الرابط والمحاولة مرة أخرى.",
      en: "The verification link is invalid or corrupted. Please check the link and try again.",
    },
    alreadyVerifiedTitle: {
      ar: "تم التحقق مسبقاً",
      en: "Already Verified",
    },
    alreadyVerifiedDesc: {
      ar: "بريدك الإلكتروني تم التحقق منه مسبقاً. يمكنك تسجيل الدخول مباشرةً.",
      en: "Your email has already been verified. You can sign in directly.",
    },
    errorTitle: {
      ar: "حدث خطأ",
      en: "An Error Occurred",
    },
    errorDesc: {
      ar: "حدث خطأ أثناء التحقق من بريدك الإلكتروني. يرجى المحاولة مرة أخرى.",
      en: "An error occurred while verifying your email. Please try again.",
    },
    // Buttons
    goHome: {
      ar: "العودة للرئيسية",
      en: "Go to Home",
    },
    goLogin: {
      ar: "الذهاب لتسجيل الدخول",
      en: "Go to Sign In",
    },
    resendEmail: {
      ar: "إعادة إرسال بريد التحقق",
      en: "Resend Verification Email",
    },
    // Info
    secureNote: {
      ar: "هذا الإجراء آمن ومشفر بالكامل",
      en: "This action is fully secure and encrypted",
    },
    emailLabel: {
      ar: "البريد الإلكتروني",
      en: "Email Address",
    },
    verifyingStep1: {
      ar: "التحقق من الرابط",
      en: "Checking the link",
    },
    verifyingStep2: {
      ar: "تأكيد البريد الإلكتروني",
      en: "Confirming email address",
    },
    verifyingStep3: {
      ar: "تفعيل الحساب",
      en: "Activating account",
    },
    pageTitle: {
      ar: "تأكيد البريد الإلكتروني",
      en: "Email Verification",
    },
  },

  // ─────────────────────────── RESET PASSWORD PAGE ─────────────────────────────
  resetPassword: {
    pageTitle: {
      ar: "إعادة تعيين كلمة السر",
      en: "Reset Password",
    },
    loadingTitle: {
      ar: "جارِ التحقق من الرابط...",
      en: "Verifying Link...",
    },
    loadingDesc: {
      ar: "يرجى الانتظار بينما نتحقق من رابط إعادة التعيين",
      en: "Please wait while we verify the reset link",
    },
    formTitle: {
      ar: "إنشاء كلمة سر جديدة",
      en: "Create New Password",
    },
    formDesc: {
      ar: "أدخل كلمة سر قوية جديدة لحسابك",
      en: "Enter a strong new password for your account",
    },
    newPasswordLabel: {
      ar: "كلمة السر الجديدة",
      en: "New Password",
    },
    newPasswordPlaceholder: {
      ar: "أدخل كلمة سر قوية",
      en: "Enter a strong password",
    },
    confirmPasswordLabel: {
      ar: "تأكيد كلمة السر",
      en: "Confirm Password",
    },
    confirmPasswordPlaceholder: {
      ar: "أعد إدخال كلمة السر",
      en: "Re-enter your password",
    },
    submitBtn: {
      ar: "تعيين كلمة السر الجديدة",
      en: "Set New Password",
    },
    submittingBtn: {
      ar: "جارِ الحفظ...",
      en: "Saving...",
    },
    successTitle: {
      ar: "تم تغيير كلمة السر! ✓",
      en: "Password Changed! ✓",
    },
    successDesc: {
      ar: "تم تغيير كلمة سرك بنجاح. يمكنك الآن تسجيل الدخول بكلمة سرك الجديدة.",
      en: "Your password has been changed successfully. You can now sign in with your new password.",
    },
    expiredTitle: {
      ar: "انتهت صلاحية الرابط",
      en: "Link Expired",
    },
    expiredDesc: {
      ar: "انتهت صلاحية رابط إعادة التعيين. يرجى طلب رابط جديد من صفحة تسجيل الدخول.",
      en: "The reset link has expired. Please request a new link from the sign-in page.",
    },
    invalidTitle: {
      ar: "رابط غير صالح",
      en: "Invalid Link",
    },
    invalidDesc: {
      ar: "رابط إعادة التعيين غير صالح أو تالف. يرجى التحقق من الرابط والمحاولة مرة أخرى.",
      en: "The reset link is invalid or corrupted. Please check the link and try again.",
    },
    errorTitle: {
      ar: "حدث خطأ",
      en: "An Error Occurred",
    },
    errorDesc: {
      ar: "حدث خطأ أثناء إعادة تعيين كلمة السر. يرجى المحاولة مرة أخرى.",
      en: "An error occurred while resetting your password. Please try again.",
    },
    // Validation
    passwordTooShort: {
      ar: "كلمة السر يجب أن تكون 8 أحرف على الأقل",
      en: "Password must be at least 8 characters",
    },
    passwordsNoMatch: {
      ar: "كلمتا السر غير متطابقتين",
      en: "Passwords do not match",
    },
    passwordWeak: {
      ar: "كلمة السر ضعيفة — استخدم أحرفاً وأرقاماً ورموزاً",
      en: "Weak password — use letters, numbers, and symbols",
    },
    // Strength
    strengthWeak: {
      ar: "ضعيفة",
      en: "Weak",
    },
    strengthFair: {
      ar: "متوسطة",
      en: "Fair",
    },
    strengthGood: {
      ar: "جيدة",
      en: "Good",
    },
    strengthStrong: {
      ar: "قوية",
      en: "Strong",
    },
    strengthLabel: {
      ar: "قوة كلمة السر:",
      en: "Password strength:",
    },
    // Requirements
    reqLength: {
      ar: "8 أحرف على الأقل",
      en: "At least 8 characters",
    },
    reqUppercase: {
      ar: "حرف كبير واحد على الأقل",
      en: "At least one uppercase letter",
    },
    reqNumber: {
      ar: "رقم واحد على الأقل",
      en: "At least one number",
    },
    reqSpecial: {
      ar: "رمز خاص واحد على الأقل",
      en: "At least one special character",
    },
    // Buttons & navigation
    goHome: {
      ar: "العودة للرئيسية",
      en: "Go to Home",
    },
    requestNewLink: {
      ar: "طلب رابط جديد",
      en: "Request New Link",
    },
    secureNote: {
      ar: "هذا الإجراء آمن ومشفر بالكامل",
      en: "This action is fully secure and encrypted",
    },
  },

  // ─────────────────────────── ADMIN PANEL ────────────────────────────────────
  admin: {
    // ── General ──────────────────────────────────────────────────────────────
    title: {
      ar: "لوحة التحكم",
      en: "Admin Panel",
    },
    home: {
      ar: "الرئيسية",
      en: "Home",
    },
    backToPanel: {
      ar: "لوحة التحكم",
      en: "Admin Panel",
    },
    connected: {
      ar: "متصل",
      en: "Connected",
    },
    disconnected: {
      ar: "غير متصل",
      en: "Disconnected",
    },
    loading: {
      ar: "جارِ التحميل...",
      en: "Loading...",
    },
    saving: {
      ar: "جارِ الحفظ...",
      en: "Saving...",
    },
    saved: {
      ar: "تم الحفظ",
      en: "Saved",
    },
    cancel: {
      ar: "إلغاء",
      en: "Cancel",
    },
    confirm: {
      ar: "تأكيد؟",
      en: "Confirm?",
    },
    delete: {
      ar: "حذف",
      en: "Delete",
    },
    edit: {
      ar: "تعديل",
      en: "Edit",
    },
    save: {
      ar: "حفظ",
      en: "Save",
    },
    total: {
      ar: "إجمالي",
      en: "Total",
    },
    static: {
      ar: "ثابت",
      en: "Static",
    },
    // ── Navigation buttons ────────────────────────────────────────────────────
    analytics: {
      ar: "الإحصائيات",
      en: "Analytics",
    },
    pendingPayments: {
      ar: "إثباتات الدفع",
      en: "Payment Proofs",
    },
    complaintsSupport: {
      ar: "الشكاوي والدعم",
      en: "Complaints & Support",
    },
    brokenPackages: {
      ar: "الحزم التالفة",
      en: "Broken Packages",
    },
    controlCenter: {
      ar: "مركز التحكم",
      en: "Control Center",
    },
    adminPages: {
      ar: "صفحات الأدمن",
      en: "Admin Pages",
    },
    performers: {
      ar: "الممثلين",
      en: "Performers",
    },
    passwords: {
      ar: "كلمات السر",
      en: "Passwords",
    },
    // ── Tabs ──────────────────────────────────────────────────────────────────
    tabAddPerformer: {
      ar: "إضافة ممثل",
      en: "Add Performer",
    },
    tabManagePerformers: {
      ar: "إدارة الممثلين",
      en: "Manage Performers",
    },
    tabPasswords: {
      ar: "كلمات السر",
      en: "Passwords",
    },
    // ── DB info banners ───────────────────────────────────────────────────────
    firestoreSync: {
      ar: "Firebase Firestore — يتزامن فوراً مع الموقع",
      en: "Firebase Firestore — syncs instantly with the site",
    },
    firestoreEditable: {
      ar: "الممثلون من Firestore قابلون للحذف والتعديل",
      en: "Firestore performers can be edited or deleted",
    },
    realtimeConnected: {
      ar: "Firebase Realtime DB — متصل",
      en: "Firebase Realtime DB — Connected",
    },
    bypassTabNote: {
      ar: 'الحزم من نوع "تخطي الروابط" لا تحتاج كلمة سر — الوصول عبر صفحات الإعلانات',
      en: '"Link Bypass" packages don\'t need a password — access via ad pages',
    },
    // ── Add/Edit Form ─────────────────────────────────────────────────────────
    nameLabel: {
      ar: "الاسم *",
      en: "Name *",
    },
    namePlaceholder: {
      ar: "مثال: Sara99",
      en: "Example: Sara99",
    },
    categoryLabel: {
      ar: "الفئة",
      en: "Category",
    },
    packageTypeLabel: {
      ar: "نوع الحزمة *",
      en: "Package Type *",
    },
    linkBypassName: {
      ar: "تخطي الروابط",
      en: "Link Bypass",
    },
    linkBypassDesc: {
      ar: "مجاني — يصل له المستخدم عبر صفحات الإعلانات",
      en: "Free — user accesses via ad pages",
    },
    pricedName: {
      ar: "بسعر (مدفوع)",
      en: "Priced (Paid)",
    },
    pricedDesc: {
      ar: "يحتاج كلمة سر بعد الشراء",
      en: "Requires a password after purchase",
    },
    hotPackageTitle: {
      ar: "حزمة ساخنة 🔥",
      en: "Hot Package 🔥",
    },
    hotPackageOn: {
      ar: "مفعّلة — ستظهر في فئة ساخن",
      en: "Enabled — will appear in Hot category",
    },
    hotPackageOff: {
      ar: "تفعيل لإظهار هذه الحزمة في فئة ساخن",
      en: "Enable to show this package in Hot category",
    },
    sizeLabel: {
      ar: "الحجم *",
      en: "Size *",
      },
    sizeHint: {
      ar: "(رقم → وحدة تلقائية)",
      en: "(number → auto unit)",
    },
    photosLabel: {
      ar: "الصور",
      en: "Photos",
    },
    photosHint: {
      ar: "(عدد)",
      en: "(count)",
    },
    videosLabel: {
      ar: "الفيديوهات",
      en: "Videos",
    },
    videosHint: {
      ar: "(عدد)",
      en: "(count)",
    },
    foldersLabel: {
      ar: "المجلدات",
      en: "Folders",
    },
    foldersHint: {
      ar: "(اختياري)",
      en: "(optional)",
    },
    priceLabel: {
      ar: "السعر",
      en: "Price",
    },
    priceRequired: {
      ar: "السعر *",
      en: "Price *",
    },
    priceHint: {
      ar: "($)",
      en: "($)",
    },
    priceFreeBypass: {
      ar: "مجاني — تخطي روابط",
      en: "Free — Link Bypass",
    },
    megaLinkLabel: {
      ar: "رابط الميجا *",
      en: "MEGA Link *",
    },
    imageLabel: {
      ar: "صورة الممثل",
      en: "Performer Image",
    },
    tagsLabel: {
      ar: "التاجات",
      en: "Tags",
    },
    // ── Image uploader ────────────────────────────────────────────────────────
    uploaderTitle: {
      ar: "اضغط لاختيار صورة أو اسحب وأفلت",
      en: "Click to choose image or drag & drop",
    },
    uploaderUploading: {
      ar: "جارِ الرفع...",
      en: "Uploading...",
    },
    uploaderChange: {
      ar: "تغيير",
      en: "Change",
    },
    uploaderWrongLink: {
      ar: "رابط خاطئ",
      en: "Invalid link",
    },
    uploaderUpload: {
      ar: "ارفع صورة",
      en: "Upload Image",
    },
    uploaderOrUrl: {
      ar: "أو أدخل رابطاً مباشراً...",
      en: "Or enter a direct URL...",
    },
    uploaderHint: {
      ar: "ارفع صورة مباشرةً أو الصق رابطاً",
      en: "Upload an image directly or paste a URL",
    },
    uploaderError: {
      ar: "فشل رفع الصورة — تحقق من الاتصال",
      en: "Upload failed — check your connection",
    },
    uploaderSuccess: {
      ar: "الصورة جاهزة",
      en: "Image ready",
    },
    uploaderInvalidType: {
      ar: "يرجى اختيار ملف صورة صالح",
      en: "Please choose a valid image file",
    },
    uploaderSizeError: {
      ar: "حجم الصورة يجب أن يكون أقل من 10MB",
      en: "Image size must be less than 10MB",
    },
    // ── Offers section ────────────────────────────────────────────────────────
    offersTitle: {
      ar: "العروض (اختياري)",
      en: "Offers (optional)",
    },
    offerTypeLabel: {
      ar: "نوع العرض",
      en: "Offer Type",
    },
    offerNone: {
      ar: "بدون عرض",
      en: "No Offer",
    },
    offerDiscount: {
      ar: "خصم %",
      en: "Discount %",
    },
    offerBundle: {
      ar: "باكيج زائد",
      en: "Bonus Package",
    },
    offerCustom: {
      ar: "باكيج خاص",
      en: "Custom Package",
    },
    offerDiscountLabel: {
      ar: "نسبة الخصم (%)",
      en: "Discount Percentage (%)",
    },
    offerEndDate: {
      ar: "تاريخ انتهاء العرض",
      en: "Offer End Date",
    },
    offerPriceAfter: {
      ar: "السعر بعد الخصم:",
      en: "Price after discount:",
    },
    offerBundleInfo: {
      ar: "عند الشراء، يمكن للمستخدم اختيار حزمة إضافية مجانية من الموقع",
      en: "Upon purchase, the user can choose an additional free package from the site",
    },
    offerCustomInfo: {
      ar: "عند الشراء، يمكن للمستخدم طلب باكيج خاص عبر تيليجرام",
      en: "Upon purchase, the user can request a custom package via Telegram",
    },
    // ── Link bypass notice ────────────────────────────────────────────────────
    bypassNoticeTitle: {
      ar: "حزمة تخطي الروابط:",
      en: "Link Bypass Package:",
    },
    bypassNoticeDesc: {
      ar: "المستخدم يصل للرابط مجاناً عبر المرور بصفحات الإعلانات (Waiting → Download → Linkequip). الموقع يربح من الإعلانات.",
      en: "The user accesses the link for free by passing through ad pages (Waiting → Download → Linkequip). The site earns from ads.",
    },
    // ── Form validation ───────────────────────────────────────────────────────
    errorNameRequired: {
      ar: "الاسم مطلوب",
      en: "Name is required",
    },
    errorMegaRequired: {
      ar: "رابط الميجا مطلوب",
      en: "MEGA link is required",
    },
    errorSizeRequired: {
      ar: "الحجم مطلوب",
      en: "Size is required",
    },
    errorPriceRequired: {
      ar: "السعر مطلوب للحزم المدفوعة",
      en: "Price is required for paid packages",
    },
    errorSaveFailed: {
      ar: "فشل الحفظ — تحقق من الاتصال",
      en: "Save failed — check your connection",
    },
    errorUpdateFailed: {
      ar: "فشل التحديث — تحقق من الاتصال",
      en: "Update failed — check your connection",
    },
    // ── Success messages ──────────────────────────────────────────────────────
    successAdded: {
      ar: "تمت الإضافة بنجاح — ظهر على الموقع فوراً ✓",
      en: "Added successfully — now visible on the site ✓",
    },
    // ── Add / Submit buttons ──────────────────────────────────────────────────
    addPerformerBtn: {
      ar: "إضافة الممثل",
      en: "Add Performer",
    },
    saveChangesBtn: {
      ar: "حفظ التعديلات",
      en: "Save Changes",
    },
    editPerformerTitle: {
      ar: "تعديل الممثل:",
      en: "Edit Performer:",
    },
    // ── Performers manager ────────────────────────────────────────────────────
    statsTotal: {
      ar: "إجمالي",
      en: "Total",
    },
    statsStatic: {
      ar: "ثابت",
      en: "Static",
    },
    statsLinkBypass: {
      ar: "تخطي روابط",
      en: "Link Bypass",
    },
    statsHot: {
      ar: "ساخنة",
      en: "Hot",
    },
    hotBadge: {
      ar: "ساخن",
      en: "Hot",
    },
    photosUnit: {
      ar: "صورة",
      en: "photo",
    },
    videosUnit: {
      ar: "فيديو",
      en: "video",
    },
    foldersUnit: {
      ar: "مجلد",
      en: "folder",
    },
    paidBadge: {
      ar: "مدفوع",
      en: "Paid",
    },
    linkBypassBadge: {
      ar: "تخطي روابط",
      en: "Link Bypass",
    },
    editTitle: {
      ar: "تعديل الممثل",
      en: "Edit Performer",
    },
    deleteConfirmTitle: {
      ar: "اضغط مجدداً للتأكيد",
      en: "Click again to confirm",
    },
    deleteTitle: {
      ar: "حذف الممثل",
      en: "Delete Performer",
    },
    // ── Password block ────────────────────────────────────────────────────────
    bypassPackageInfo: {
      ar: "هذه الحزمة من نوع تخطي الروابط — لا تحتاج كلمة سر، الوصول عبر صفحات الإعلانات",
      en: "This is a link bypass package — no password needed, access via ad pages",
    },
    generateBtn: {
      ar: "إنشاء",
      en: "Generate",
    },
    passwordExpiry: {
      ar: "تنتهي عند الاستخدام أو الحذف اليدوي",
      en: "Expires upon use or manual deletion",
    },
    noActivePasswords: {
      ar: "لا توجد كلمات سر نشطة",
      en: "No active passwords",
    },
    bypassLinkBadge: {
      ar: "تخطي روابط",
      en: "Link Bypass",
    },

    // ── AdminHub ──────────────────────────────────────────────────────────────
    hubTitle: {
      ar: "مركز التحكم",
      en: "Control Center",
    },
    hubSubtitle: {
      ar: "Leaks Mercy Admin Hub",
      en: "Leaks Mercy Admin Hub",
    },
    // Stats
    totalPackages: {
      ar: "إجمالي الحزم",
      en: "Total Packages",
    },
    pendingPaymentsCount: {
      ar: "دفعات معلقة",
      en: "Pending Payments",
    },
    pendingComplaints: {
      ar: "شكاوي قيد الانتظار",
      en: "Pending Complaints",
    },
    brokenPackagesCount: {
      ar: "حزم تالفة",
      en: "Broken Packages",
    },
    // Urgent banner
    urgentBroken: {
      ar: "حزمة تالفة تحتاج مراجعة",
      en: "broken package(s) need review",
    },
    urgentPayments: {
      ar: "إثبات دفع معلق",
      en: "pending payment proof(s)",
    },
    reviewNow: {
      ar: "مراجعة الآن",
      en: "Review Now",
    },
    // Sections
    sectionPackages: {
      ar: "إدارة الحزم",
      en: "Package Management",
    },
    sectionFinance: {
      ar: "المالية والمدفوعات",
      en: "Finance & Payments",
    },
    sectionUsers: {
      ar: "خدمة المستخدمين",
      en: "User Service",
    },
    sectionAnalytics: {
      ar: "التحليلات والمراقبة",
      en: "Analytics & Monitoring",
    },
    // Cards
    cardManagePackages: {
      ar: "إضافة وإدارة الحزم",
      en: "Add & Manage Packages",
    },
    cardManagePackagesDesc: {
      ar: "إضافة حزم جديدة، تعديل الموجودة، أو حذف الحزم",
      en: "Add new packages, edit existing ones, or delete packages",
    },
    cardPasswords: {
      ar: "كلمات السر",
      en: "Passwords",
    },
    cardPasswordsDesc: {
      ar: "إنشاء وإدارة كلمات سر الحزم المدفوعة",
      en: "Create and manage passwords for paid packages",
    },
    cardBroken: {
      ar: "الحزم التالفة",
      en: "Broken Packages",
    },
    cardBrokenDesc: {
      ar: "مراقبة روابط الميجا وإصلاح الروابط المكسورة",
      en: "Monitor MEGA links and fix broken ones",
    },
    cardPaymentProofs: {
      ar: "إثباتات الدفع",
      en: "Payment Proofs",
    },
    cardPaymentProofsDesc: {
      ar: "مراجعة وقبول أو رفض إثباتات دفع المستخدمين",
      en: "Review, approve, or reject user payment proofs",
    },
    cardComplaints: {
      ar: "الشكاوي",
      en: "Complaints",
    },
    cardComplaintsDesc: {
      ar: "عرض والرد على شكاوي المستخدمين",
      en: "View and respond to user complaints",
    },
    cardSupportRequests: {
      ar: "طلبات الدعم",
      en: "Support Requests",
    },
    cardSupportRequestsDesc: {
      ar: "عرض والرد على طلبات الدعم الفني للمستخدمين",
      en: "View and respond to user technical support requests",
    },
    cardSiteStats: {
      ar: "إحصائيات الموقع",
      en: "Site Analytics",
    },
    cardSiteStatsDesc: {
      ar: "تحليلات الزيارات، الأجهزة، الدول، ومصادر الزيارات",
      en: "Visit analytics, devices, countries, and traffic sources",
    },
    cardPerformanceMonitor: {
      ar: "مراقبة الأداء",
      en: "Performance Monitoring",
    },
    cardPerformanceMonitorDesc: {
      ar: "مؤشرات الموقع الحية: الزوار النشطون، معدل التحويل",
      en: "Live site indicators: active visitors, conversion rate",
    },
    // Footer
    footerFirebase: {
      ar: "Firebase Realtime DB + Firestore — متزامن",
      en: "Firebase Realtime DB + Firestore — Synced",
    },
    footerOwnerOnly: {
      ar: "وصول محدود لمالكي الموقع فقط",
      en: "Access restricted to site owners only",
    },

    // ── PendingPayments ───────────────────────────────────────────────────────
    pendingPaymentsTitle: {
      ar: "إثباتات الدفع المعلقة",
      en: "Pending Payment Proofs",
    },
    // Status labels
    statusPending: {
      ar: "معلق",
      en: "Pending",
    },
    statusApproved: {
      ar: "مقبول",
      en: "Approved",
    },
    statusRejected: {
      ar: "مرفوض",
      en: "Rejected",
    },
    statusAll: {
      ar: "الكل",
      en: "All",
    },
    // Stats
    statPending: {
      ar: "معلق",
      en: "Pending",
    },
    statApproved: {
      ar: "مقبول",
      en: "Approved",
    },
    statRejected: {
      ar: "مرفوض",
      en: "Rejected",
    },
    statTotal: {
      ar: "المجموع",
      en: "Total",
    },
    // Fields
    transferNumber: {
      ar: "رقم التحويل",
      en: "Transfer Number",
    },
    purchasedPackage: {
      ar: "الحزمة المشتراة",
      en: "Purchased Package",
    },
    sendTime: {
      ar: "وقت الإرسال",
      en: "Submission Time",
    },
    proofImage: {
      ar: "صورة إثبات الدفع",
      en: "Payment Proof Image",
    },
    noImage: {
      ar: "لا توجد صورة",
      en: "No image",
    },
    viewProof: {
      ar: "عرض الإثبات",
      en: "View Proof",
    },
    passwordSent: {
      ar: "كلمة السر المُرسلة:",
      en: "Password Sent:",
    },
    // Actions
    approveBtn: {
      ar: "قبول وإرسال كلمة السر",
      en: "Approve & Send Password",
    },
    approvingBtn: {
      ar: "جارِ القبول...",
      en: "Approving...",
    },
    rejectBtn: {
      ar: "رفض",
      en: "Reject",
    },
    rejectingBtn: {
      ar: "جارِ الرفض...",
      en: "Rejecting...",
    },
    rejectConfirmBtn: {
      ar: "تأكيد الرفض؟",
      en: "Confirm Rejection?",
    },
    deleteConfirmBtn: {
      ar: "تأكيد الحذف؟",
      en: "Confirm Delete?",
    },
    approvedResult: {
      ar: "تم القبول وإرسال كلمة السر",
      en: "Approved & password sent",
    },
    rejectedResult: {
      ar: "تم رفض الإثبات",
      en: "Proof rejected",
    },
    openInTab: {
      ar: "فتح في تبويب جديد",
      en: "Open in new tab",
    },
    // Search
    searchByPhone: {
      ar: "بحث برقم الهاتف...",
      en: "Search by phone number...",
    },
    // Empty states
    noPendingProofs: {
      ar: "لا توجد إثباتات معلقة حالياً",
      en: "No pending proofs at the moment",
    },
    noProofsYet: {
      ar: "لا توجد إثباتات بعد",
      en: "No proofs yet",
    },
    noApprovedProofs: {
      ar: "لا توجد إثباتات مقبولة",
      en: "No approved proofs",
    },
    noRejectedProofs: {
      ar: "لا توجد إثباتات مرفوضة",
      en: "No rejected proofs",
    },
    loadingProofs: {
      ar: "جارِ تحميل الإثباتات...",
      en: "Loading proofs...",
    },

    // ── RespondingComplaints ──────────────────────────────────────────────────
    complaintsTitle: {
      ar: "الرد على الشكاوي والدعم",
      en: "Respond to Complaints & Support",
    },
    // Stats bar
    totalComplaints: {
      ar: "إجمالي الشكاوي",
      en: "Total Complaints",
    },
    supportRequests: {
      ar: "طلبات الدعم",
      en: "Support Requests",
    },
    awaitingReply: {
      ar: "قيد الانتظار",
      en: "Awaiting Reply",
    },
    replied: {
      ar: "تم الرد",
      en: "Replied",
    },
    // Tabs
    complaintsTab: {
      ar: "الشكاوي",
      en: "Complaints",
    },
    supportTab: {
      ar: "طلبات الدعم",
      en: "Support Requests",
    },
    // Status filter options
    filterAll: {
      ar: "الكل",
      en: "All",
    },
    filterPending: {
      ar: "قيد الانتظار",
      en: "Pending",
    },
    filterInProgress: {
      ar: "جارِ المراجعة",
      en: "In Review",
    },
    filterResolved: {
      ar: "تم الحل",
      en: "Resolved",
    },
    filterClosed: {
      ar: "مغلق",
      en: "Closed",
    },
    // Search
    searchPlaceholder: {
      ar: "البحث بالموضوع أو الاسم أو البريد...",
      en: "Search by subject, name, or email...",
    },
    // Ticket fields
    userInfoSection: {
      ar: "معلومات المستخدم",
      en: "User Info",
    },
    userMessageSection: {
      ar: "رسالة المستخدم",
      en: "User Message",
    },
    changeStatusSection: {
      ar: "تغيير الحالة",
      en: "Change Status",
    },
    replySection: {
      ar: "الرد على",
      en: "Reply to",
    },
    replyComplaint: {
      ar: "الشكوى",
      en: "the complaint",
    },
    replySupportRequest: {
      ar: "طلب الدعم",
      en: "the support request",
    },
    replyPlaceholder: {
      ar: "اكتب ردك هنا... سيظهر للمستخدم في صندوق بريده",
      en: "Write your reply here... it will appear in the user's mailbox",
    },
    sendingReply: {
      ar: "جارِ الإرسال...",
      en: "Sending...",
    },
    replySent: {
      ar: "تم الإرسال ✓",
      en: "Sent ✓",
    },
    sendReplyBtn: {
      ar: "إرسال الرد",
      en: "Send Reply",
    },
    notRepliedYet: {
      ar: "لم يُرَد بعد",
      en: "Not replied yet",
    },
    hasReplied: {
      ar: "تم الرد",
      en: "Replied",
    },
    guestUser: {
      ar: "زائر مؤقت",
      en: "Guest",
    },
    member: {
      ar: "عضو",
      en: "Member",
    },
    viewProfile: {
      ar: "الملف الشخصي",
      en: "Profile",
    },
    user: {
      ar: "مستخدم",
      en: "User",
    },
    noMessages: {
      ar: "لا توجد رسائل",
      en: "No messages",
    },
    noMessagesFiltered: {
      ar: "لا توجد رسائل بهذه الحالة",
      en: "No messages with this status",
    },
    loadingData: {
      ar: "جارِ تحميل البيانات...",
      en: "Loading data...",
    },

    // ── AnalyticsPage ─────────────────────────────────────────────────────────
    analyticsTitle: {
      ar: "إحصائيات الموقع",
      en: "Site Analytics",
    },
    activeNow: {
      ar: "نشط الآن",
      en: "Active Now",
    },
    refreshBtn: {
      ar: "تحديث",
      en: "Refresh",
    },
    fetchingBtn: {
      ar: "جارِ الجلب...",
      en: "Fetching...",
    },
    timePeriod: {
      ar: "الفترة الزمنية:",
      en: "Time Period:",
    },
    last24h: {
      ar: "24 ساعة",
      en: "24 hours",
    },
    last7days: {
      ar: "7 أيام",
      en: "7 days",
    },
    last14days: {
      ar: "14 يوم",
      en: "14 days",
    },
    last30days: {
      ar: "30 يوم",
      en: "30 days",
    },
    last90days: {
      ar: "90 يوم",
      en: "90 days",
    },
    allTime: {
      ar: "كل الوقت",
      en: "All Time",
    },
    rangePrefix: {
      ar: "آخر",
      en: "Last",
    },
    rangeDays: {
      ar: "يوم",
      en: "days",
    },
    rangeLast24h: {
      ar: "آخر 24 ساعة",
      en: "Last 24 hours",
    },
    lastUpdated: {
      ar: "آخر تحديث:",
      en: "Last updated:",
    },
    errorFetchTitle: {
      ar: "تعذّر جلب البيانات",
      en: "Failed to Fetch Data",
    },
    retryBtn: {
      ar: "إعادة المحاولة",
      en: "Retry",
    },
    checkingAuth: {
      ar: "جارِ التحقق من الصلاحيات...",
      en: "Checking permissions...",
    },
    // KPI Cards
    totalViews: {
      ar: "إجمالي المشاهدات",
      en: "Total Views",
    },
    uniqueUsers: {
      ar: "المستخدمون الفريدون",
      en: "Unique Users",
    },
    totalSessions: {
      ar: "إجمالي الجلسات",
      en: "Total Sessions",
    },
    avgSessionTime: {
      ar: "متوسط وقت الجلسة",
      en: "Average Session Time",
    },
    minuteSecond: {
      ar: "دقيقة:ثانية",
      en: "minute:second",
    },
    bounceRate: {
      ar: "معدل الارتداد",
      en: "Bounce Rate",
    },
    pagesPerSession: {
      ar: "الصفحات لكل جلسة",
      en: "Pages per Session",
    },
    pagesAvg: {
      ar: "صفحة بالمتوسط",
      en: "pages on average",
    },
    newUsersLabel: {
      ar: "المستخدمون الجدد",
      en: "New Users",
    },
    ofAll: {
      ar: "من الكل",
      en: "of total",
    },
    activeUsersNow: {
      ar: "المستخدمون النشطون الآن",
      en: "Active Users Now",
    },
    realtime: {
      ar: "في الوقت الحقيقي",
      en: "Real-time",
    },
    newUserSuffix: {
      ar: "مستخدم جديد",
      en: "new user(s)",
    },
    engagedSessions: {
      ar: "جلسة متفاعلة",
      en: "engaged session(s)",
    },
    bounceExcellent: {
      ar: "ممتاز (أقل من 40%)",
      en: "Excellent (under 40%)",
    },
    bounceGood: {
      ar: "جيد",
      en: "Good",
    },
    bounceImprove: {
      ar: "يحتاج تحسين",
      en: "Needs improvement",
    },
    // Charts
    visitTimeline: {
      ar: "مخطط الزيارات الزمني",
      en: "Visit Timeline",
    },
    trafficSources: {
      ar: "مصادر الزيارات",
      en: "Traffic Sources",
    },
    devicesSection: {
      ar: "الأجهزة",
      en: "Devices",
    },
    pageVisits: {
      ar: "زيارات الصفحات",
      en: "Page Visits",
    },
    countryVisits: {
      ar: "زيارات الدول",
      en: "Country Visits",
    },
    topEvents: {
      ar: "أكثر الأحداث تكراراً",
      en: "Top Events",
    },
    osSystems: {
      ar: "أنظمة التشغيل",
      en: "Operating Systems",
    },
    userUnit: {
      ar: "مستخدم",
      en: "user(s)",
    },
    pageUnit: {
      ar: "صفحة",
      en: "page(s)",
    },
    countryUnit: {
      ar: "دولة",
      en: "country(ies)",
    },
    noData: {
      ar: "لا توجد بيانات",
      en: "No data",
    },
    noTimeData: {
      ar: "لا توجد بيانات زمنية للفترة المختارة",
      en: "No time data for the selected period",
    },
    clickBarHint: {
      ar: "انقر على أي شريط لعرض إحصائياته الكاملة",
      en: "Click any bar to view its full statistics",
    },
    clickBarSelected: {
      ar: "انقر على أي شريط لعرض تفاصيله",
      en: "Click any bar to view its details",
    },
    dayStatsTitle: {
      ar: "إحصائيات:",
      en: "Statistics:",
    },
    // Metric labels for timeline
    metricViews: {
      ar: "مشاهدات",
      en: "Views",
    },
    metricSessions: {
      ar: "جلسات",
      en: "Sessions",
    },
    metricUsers: {
      ar: "مستخدمين",
      en: "Users",
    },

    // ── BrokenPackages ────────────────────────────────────────────────────────
    brokenPackagesTitle: {
      ar: "الحزم التالفة",
      en: "Broken Packages",
    },
    brokenCount: {
      ar: "تالفة",
      en: "Broken",
    },
    resolvedCount: {
      ar: "تم إصلاحها",
      en: "Fixed",
    },
    totalCount: {
      ar: "الإجمالي",
      en: "Total",
    },
    brokenAlert: {
      ar: "روابطها تالفة. قم بتعديل الروابط لإصلاحها.",
      en: "have broken links. Edit the links to fix them.",
    },
    packageLabel: {
      ar: "حزمة",
      en: "package",
    },
    packagesLabel: {
      ar: "حزم",
      en: "packages",
    },
    filterBroken: {
      ar: "التالفة",
      en: "Broken",
    },
    filterResolved: {
      ar: "المُصلَحة",
      en: "Fixed",
    },
    filterAllPackages: {
      ar: "الكل",
      en: "All",
    },
    searchPackagePlaceholder: {
      ar: "بحث باسم الحزمة أو الرابط...",
      en: "Search by package name or link...",
    },
    detectedLabel: {
      ar: "اكتُشف",
      en: "Detected",
    },
    checkedLabel: {
      ar: "فُحص",
      en: "Checked",
    },
    timesLabel: {
      ar: "مرة",
      en: "time(s)",
    },
    statusFixed: {
      ar: "تم الإصلاح",
      en: "Fixed",
    },
    statusBroken: {
      ar: "رابط تالف",
      en: "Broken Link",
    },
    expandBtn: {
      ar: "توسعة",
      en: "Expand",
    },
    collapseBtn: {
      ar: "طي",
      en: "Collapse",
    },
    megaLinkCurrent: {
      ar: "رابط الميجا الحالي",
      en: "Current MEGA Link",
    },
    noLink: {
      ar: "لا يوجد رابط",
      en: "No link",
    },
    openInNewTab: {
      ar: "فتح الرابط في تبويب جديد",
      en: "Open link in new tab",
    },
    editLink: {
      ar: "تعديل الرابط",
      en: "Edit Link",
    },
    editMegaLink: {
      ar: "تعديل رابط الميجا",
      en: "Edit MEGA Link",
    },
    cancelEdit: {
      ar: "إلغاء",
      en: "Cancel",
    },
    savingLink: {
      ar: "جارِ الحفظ...",
      en: "Saving...",
    },
    saveNewLink: {
      ar: "حفظ الرابط الجديد",
      en: "Save New Link",
    },
    errorEmptyLink: {
      ar: "الرابط لا يمكن أن يكون فارغاً",
      en: "Link cannot be empty",
    },
    errorInvalidMega: {
      ar: "يجب أن يكون رابط Mega صالحاً (mega.nz)",
      en: "Must be a valid Mega link (mega.nz)",
    },
    errorSaveLink: {
      ar: "فشل الحفظ — تحقق من الاتصال",
      en: "Save failed — check your connection",
    },
    detectedDate: {
      ar: "تاريخ الاكتشاف:",
      en: "Detected on:",
    },
    lastChecked: {
      ar: "آخر فحص:",
      en: "Last checked:",
    },
    resolvedDate: {
      ar: "تاريخ الإصلاح:",
      en: "Fixed on:",
    },
    markResolvedBtn: {
      ar: "تحديد كمُصلَح",
      en: "Mark as Fixed",
    },
    markResolvedTitle: {
      ar: "وضع علامة 'تم الإصلاح' يدوياً",
      en: "Manually mark as resolved",
    },
    updatingBtn: {
      ar: "جارِ التحديث...",
      en: "Updating...",
    },
    deleteBtnTitle: {
      ar: "حذف من قائمة التالفة",
      en: "Remove from broken list",
    },
    noBrokenPackages: {
      ar: "🎉 لا توجد حزم تالفة حالياً",
      en: "🎉 No broken packages at the moment",
    },
    allLinksWorking: {
      ar: "كل روابط الميجا تعمل بشكل صحيح",
      en: "All MEGA links are working correctly",
    },
    noResolvedPackages: {
      ar: "لا توجد حزم مُصلَحة بعد",
      en: "No fixed packages yet",
    },
    noDataAvailable: {
      ar: "لا توجد بيانات",
      en: "No data available",
    },
    willAppearHere: {
      ar: "ستظهر هنا الحزم عند فحصها",
      en: "Packages will appear here once checked",
    },
    loadingBroken: {
      ar: "جارِ تحميل البيانات...",
      en: "Loading data...",
    },
    autoCheckerInfo: {
      ar: "الفحص التلقائي لروابط الميجا نشط — يعمل في الخلفية كل 15 ثانية لكل رابط",
      en: "Auto MEGA link checker is active — runs in the background every 15 seconds per link",
    },
    // ── PendingPayments ───────────────────────────────────────────────────────
    approveAndSendPassword: {
      ar: "قبول وإرسال كلمة السر",
      en: "Approve & Send Password",
    },
    approvedAndSent: {
      ar: "تم القبول وإرسال كلمة السر",
      en: "Approved & Password Sent",
    },
    approvingNow: {
      ar: "جارِ القبول...",
      en: "Approving...",
    },
    rejectingNow: {
      ar: "جارِ الرفض...",
      en: "Rejecting...",
    },
    confirmReject: {
      ar: "تأكيد الرفض؟",
      en: "Confirm Reject?",
    },
    confirmDelete: {
      ar: "تأكيد الحذف؟",
      en: "Confirm Delete?",
    },
    reject: {
      ar: "رفض",
      en: "Reject",
    },
    proofRejected: {
      ar: "تم رفض الإثبات",
      en: "Proof Rejected",
    },
    sentPassword: {
      ar: "كلمة السر المُرسلة:",
      en: "Sent Password:",
    },
    proofAlt: {
      ar: "إثبات",
      en: "Proof",
    },
    proofImageAlt: {
      ar: "إثبات الدفع",
      en: "Payment Proof",
    },
    viewProof: {
      ar: "عرض الإثبات",
      en: "View Proof",
    },
    noImage: {
      ar: "لا توجد صورة",
      en: "No image",
    },
    transferNumber: {
      ar: "رقم التحويل",
      en: "Transfer Number",
    },
    purchasedPackage: {
      ar: "الحزمة المشتراة",
      en: "Purchased Package",
    },
    sendTime: {
      ar: "وقت الإرسال",
      en: "Send Time",
    },
    connected: {
      ar: "متصل",
      en: "Connected",
    },
    disconnected: {
      ar: "غير متصل",
      en: "Disconnected",
    },
    backToPanel: {
      ar: "لوحة التحكم",
      en: "Admin Panel",
    },
    pendingPaymentsTitle: {
      ar: "إثباتات الدفع المعلقة",
      en: "Pending Payment Proofs",
    },
    filterAll: {
      ar: "الكل",
      en: "All",
    },
    searchByPhone: {
      ar: "بحث برقم الهاتف...",
      en: "Search by phone number...",
    },
    loadingProofs: {
      ar: "جارِ تحميل الإثباتات...",
      en: "Loading proofs...",
    },
    emptyPending: {
      ar: "لا توجد إثباتات معلقة حالياً",
      en: "No pending proofs right now",
    },
    emptyAll: {
      ar: "لا توجد إثباتات بعد",
      en: "No proofs yet",
    },
    emptyApproved: {
      ar: "لا توجد إثباتات مقبولة",
      en: "No approved proofs",
    },
    emptyRejected: {
      ar: "لا توجد إثباتات مرفوضة",
      en: "No rejected proofs",
    },
    deleteFromList: {
      ar: "حذف من القائمة",
      en: "Delete from list",
    },
    openInNewTab: {
      ar: "فتح في تبويب جديد",
      en: "Open in new tab",
    },
    timeAgoDays: {
      ar: "منذ {n} يوم",
      en: "{n} day(s) ago",
    },
    timeAgoHours: {
      ar: "منذ {n} ساعة",
      en: "{n} hour(s) ago",
    },
    timeAgoMins: {
      ar: "منذ {n} دقيقة",
      en: "{n} min(s) ago",
    },
    timeAgoNow: {
      ar: "الآن",
      en: "Just now",
    },
    // ── RespondingComplaints ──────────────────────────────────────────────────
    statusAll: {
      ar: "الكل",
      en: "All",
    },
    statusPending2: {
      ar: "قيد الانتظار",
      en: "Pending",
    },
    statusInProgress: {
      ar: "جارِ المراجعة",
      en: "In Progress",
    },
    statusResolved: {
      ar: "تم الحل",
      en: "Resolved",
    },
    statusClosed: {
      ar: "مغلق",
      en: "Closed",
    },
    complaintsTitle: {
      ar: "الرد على الشكاوي والدعم",
      en: "Complaints & Support",
    },
    complaintsTab: {
      ar: "الشكاوي",
      en: "Complaints",
    },
    supportTab: {
      ar: "طلبات الدعم",
      en: "Support Requests",
    },
    totalComplaints: {
      ar: "إجمالي الشكاوي",
      en: "Total Complaints",
    },
    supportRequests: {
      ar: "طلبات الدعم",
      en: "Support Requests",
    },
    replied: {
      ar: "تم الرد",
      en: "Replied",
    },
    notRepliedYet: {
      ar: "لم يُرَد بعد",
      en: "Not replied yet",
    },
    changeStatus: {
      ar: "تغيير الحالة",
      en: "Change Status",
    },
    userInfo: {
      ar: "معلومات المستخدم",
      en: "User Info",
    },
    userMessage: {
      ar: "رسالة المستخدم",
      en: "User Message",
    },
    replyToComplaint: {
      ar: "الرد على الشكوى",
      en: "Reply to Complaint",
    },
    replyToSupport: {
      ar: "الرد على طلب الدعم",
      en: "Reply to Support Request",
    },
    replyPlaceholder: {
      ar: "اكتب ردك هنا... سيظهر للمستخدم في صندوق بريده",
      en: "Write your reply here... it will appear in the user's mailbox",
    },
    sendReply: {
      ar: "إرسال الرد",
      en: "Send Reply",
    },
    sendingReply: {
      ar: "جارِ الإرسال...",
      en: "Sending...",
    },
    replySent: {
      ar: "تم الإرسال ✓",
      en: "Sent ✓",
    },
    searchTickets: {
      ar: "البحث بالموضوع أو الاسم أو البريد...",
      en: "Search by subject, name or email...",
    },
    loadingData: {
      ar: "جارِ تحميل البيانات...",
      en: "Loading data...",
    },
    emptyWithFilter: {
      ar: "لا توجد رسائل بهذه الحالة",
      en: "No messages with this status",
    },
    emptyNoMessages: {
      ar: "لا توجد رسائل",
      en: "No messages",
    },
    unknownUser: {
      ar: "مستخدم",
      en: "User",
    },
    guestUser: {
      ar: "زائر مؤقت",
      en: "Guest",
    },
    member: {
      ar: "عضو",
      en: "Member",
    },
    viewProfile: {
      ar: "عرض الملف الشخصي",
      en: "View Profile",
    },
    profileBtn: {
      ar: "الملف الشخصي",
      en: "Profile",
    },
    // ── AnalyticsPage ─────────────────────────────────────────────────────────
    analyticsTitle: {
      ar: "إحصائيات الموقع",
      en: "Site Analytics",
    },
    activeNow: {
      ar: "نشط الآن",
      en: "Active Now",
    },
    fetching: {
      ar: "جارِ الجلب...",
      en: "Fetching...",
    },
    refresh: {
      ar: "تحديث",
      en: "Refresh",
    },
    lastUpdate: {
      ar: "آخر تحديث",
      en: "Last update",
    },
    timePeriod: {
      ar: "الفترة الزمنية",
      en: "Time Period",
    },
    range24h: {
      ar: "24 ساعة",
      en: "24h",
    },
    range7d: {
      ar: "7 أيام",
      en: "7 days",
    },
    range14d: {
      ar: "14 يوم",
      en: "14 days",
    },
    range30d: {
      ar: "30 يوم",
      en: "30 days",
    },
    range90d: {
      ar: "90 يوم",
      en: "90 days",
    },
    rangeAll: {
      ar: "كل الوقت",
      en: "All Time",
    },
    rangeLast24h: {
      ar: "آخر 24 ساعة",
      en: "Last 24 hours",
    },
    rangeLastNDays: {
      ar: "آخر {n} يوم",
      en: "Last {n} days",
    },
    fetchErrorTitle: {
      ar: "تعذّر جلب البيانات",
      en: "Failed to fetch data",
    },
    fetchError: {
      ar: "تعذر جلب البيانات من السيرفر",
      en: "Could not fetch data from server",
    },
    fetchFailed: {
      ar: "فشل جلب البيانات",
      en: "Data fetch failed",
    },
    retry: {
      ar: "إعادة المحاولة",
      en: "Retry",
    },
    checkingAuth: {
      ar: "جارِ التحقق من الصلاحيات...",
      en: "Checking permissions...",
    },
    metricViews: {
      ar: "مشاهدات",
      en: "Views",
    },
    metricSessions: {
      ar: "جلسات",
      en: "Sessions",
    },
    metricUsers: {
      ar: "مستخدمين",
      en: "Users",
    },
    kpiTotalViews: {
      ar: "إجمالي المشاهدات",
      en: "Total Views",
    },
    kpiUniqueUsers: {
      ar: "المستخدمون الفريدون",
      en: "Unique Users",
    },
    kpiTotalSessions: {
      ar: "إجمالي الجلسات",
      en: "Total Sessions",
    },
    kpiAvgSession: {
      ar: "متوسط وقت الجلسة",
      en: "Avg. Session Time",
    },
    kpiBounceRate: {
      ar: "معدل الارتداد",
      en: "Bounce Rate",
    },
    kpiPagesPerSession: {
      ar: "الصفحات لكل جلسة",
      en: "Pages per Session",
    },
    kpiNewUsers: {
      ar: "المستخدمون الجدد",
      en: "New Users",
    },
    kpiActiveNow: {
      ar: "المستخدمون النشطون الآن",
      en: "Active Users Now",
    },
    newUser: {
      ar: "مستخدم جديد",
      en: "new user",
    },
    engagedSession: {
      ar: "جلسة متفاعلة",
      en: "engaged session",
    },
    minSec: {
      ar: "دقيقة:ثانية",
      en: "min:sec",
    },
    bounceNeedsWork: {
      ar: "يحتاج تحسين",
      en: "Needs work",
    },
    bounceExcellent: {
      ar: "ممتاز (أقل من 40%)",
      en: "Excellent (under 40%)",
    },
    bounceGood: {
      ar: "جيد",
      en: "Good",
    },
    pageAvg: {
      ar: "صفحة بالمتوسط",
      en: "pages on avg",
    },
    ofTotal: {
      ar: "من الكل",
      en: "of total",
    },
    realtime: {
      ar: "في الوقت الحقيقي",
      en: "Real-time",
    },
    timelineChart: {
      ar: "مخطط الزيارات الزمني",
      en: "Traffic Timeline",
    },
    trafficSources: {
      ar: "مصادر الزيارات",
      en: "Traffic Sources",
    },
    noTimelineData: {
      ar: "لا توجد بيانات زمنية للفترة المختارة",
      en: "No timeline data for selected period",
    },
    noData: {
      ar: "لا توجد بيانات",
      en: "No data",
    },
    clickBarHint: {
      ar: "انقر على أي شريط لعرض تفاصيله",
      en: "Click any bar to view details",
    },
    clickBarFull: {
      ar: "انقر على أي شريط لعرض إحصائياته الكاملة",
      en: "Click any bar to view full stats",
    },
    devices: {
      ar: "الأجهزة",
      en: "Devices",
    },
    operatingSystems: {
      ar: "أنظمة التشغيل",
      en: "Operating Systems",
    },
    pageVisits: {
      ar: "زيارات الصفحات",
      en: "Page Visits",
    },
    pageCount: {
      ar: "صفحة",
      en: "pages",
    },
    countryVisits: {
      ar: "زيارات الدول",
      en: "Country Visits",
    },
    countryCount: {
      ar: "دولة",
      en: "countries",
    },
    topEvents: {
      ar: "أكثر الأحداث تكراراً",
      en: "Top Events",
    },
    dayStats: {
      ar: "إحصائيات",
      en: "Stats",
    },
    // ── BrokenPackages ────────────────────────────────────────────────────────
    brokenPackagesTitle: {
      ar: "الحزم التالفة",
      en: "Broken Packages",
    },
    statusFixed: {
      ar: "تم الإصلاح",
      en: "Fixed",
    },
    statusBrokenLink: {
      ar: "رابط تالف",
      en: "Broken Link",
    },
    filterBroken: {
      ar: "التالفة",
      en: "Broken",
    },
    filterResolved: {
      ar: "المُصلَحة",
      en: "Fixed",
    },
    statBroken: {
      ar: "تالفة",
      en: "Broken",
    },
    statResolved: {
      ar: "تم إصلاحها",
      en: "Fixed",
    },
    brokenAlert: {
      ar: "يوجد {n} حزم روابطها تالفة. قم بتعديل الروابط لإصلاحها.",
      en: "There are {n} package(s) with broken links. Edit the links to fix them.",
    },
    detectedAgo: {
      ar: "اكتُشف {ago}",
      en: "Detected {ago}",
    },
    checkedNTimes: {
      ar: "فُحص {n} مرة",
      en: "Checked {n} time(s)",
    },
    collapse: {
      ar: "طي",
      en: "Collapse",
    },
    expand: {
      ar: "توسعة",
      en: "Expand",
    },
    currentMegaLink: {
      ar: "رابط الميجا الحالي",
      en: "Current MEGA Link",
    },
    noLink: {
      ar: "لا يوجد رابط",
      en: "No link",
    },
    editLink: {
      ar: "تعديل الرابط",
      en: "Edit Link",
    },
    editMegaLink: {
      ar: "تعديل رابط الميجا",
      en: "Edit MEGA Link",
    },
    saveNewLink: {
      ar: "حفظ الرابط الجديد",
      en: "Save New Link",
    },
    savingLink: {
      ar: "جارِ الحفظ...",
      en: "Saving...",
    },
    errorLinkEmpty: {
      ar: "الرابط لا يمكن أن يكون فارغاً",
      en: "Link cannot be empty",
    },
    errorLinkInvalid: {
      ar: "يجب أن يكون رابط Mega صالحاً (mega.nz)",
      en: "Must be a valid Mega link (mega.nz)",
    },
    errorSaveFailed: {
      ar: "فشل الحفظ — تحقق من الاتصال",
      en: "Save failed — check your connection",
    },
    errorUpdateFailed: {
      ar: "فشل التحديث",
      en: "Update failed",
    },
    detectedAt: {
      ar: "تاريخ الاكتشاف",
      en: "Detected",
    },
    lastChecked: {
      ar: "آخر فحص",
      en: "Last check",
    },
    resolvedAt: {
      ar: "تاريخ الإصلاح",
      en: "Fixed on",
    },
    markResolved: {
      ar: "تحديد كمُصلَح",
      en: "Mark as Fixed",
    },
    markResolvedHint: {
      ar: "وضع علامة 'تم الإصلاح' يدوياً",
      en: "Manually mark as fixed",
    },
    updating: {
      ar: "جارِ التحديث...",
      en: "Updating...",
    },
    searchByNameOrLink: {
      ar: "بحث باسم الحزمة أو الرابط...",
      en: "Search by package name or link...",
    },
    emptyBroken: {
      ar: "🎉 لا توجد حزم تالفة حالياً",
      en: "🎉 No broken packages right now",
    },
    emptyBrokenSub: {
      ar: "كل روابط الميجا تعمل بشكل صحيح",
      en: "All MEGA links are working correctly",
    },
    emptyResolved: {
      ar: "لا توجد حزم مُصلَحة بعد",
      en: "No fixed packages yet",
    },
    emptyResolvedSub: {
      ar: "ستظهر هنا الحزم عند فحصها",
      en: "Packages will appear here once checked",
    },
    emptyNoData: {
      ar: "لا توجد بيانات",
      en: "No data",
    },
    // ── Suspend / Permanent Delete ────────────────────────────────────────────
    statusSuspended: {
      ar: "معلّق",
      en: "Suspended",
    },
    suspendedTag: {
      ar: "معلّقة",
      en: "Suspended",
    },
    suspendNotice: {
      ar: "هذه الحزمة معلّقة مؤقتاً — لن يتمكن المستخدمون من الوصول إليها حتى يتم إلغاء التعليق أو إصلاح الرابط.",
      en: "This package is temporarily suspended — users cannot access it until it is unsuspended or the link is fixed.",
    },
    suspendBtn: {
      ar: "تعليق مؤقت",
      en: "Suspend",
    },
    unsuspendBtn: {
      ar: "إلغاء التعليق",
      en: "Unsuspend",
    },
    suspendHint: {
      ar: "تعليق الحزمة مؤقتاً (تبقى في القائمة لكن غير متاحة)",
      en: "Temporarily suspend this package (stays in list but inaccessible)",
    },
    unsuspendHint: {
      ar: "إلغاء تعليق الحزمة وإعادتها للمتاحة",
      en: "Unsuspend and restore package availability",
    },
    suspendedAt: {
      ar: "تاريخ التعليق",
      en: "Suspended on",
    },
    filterSuspended: {
      ar: "المعلّقة",
      en: "Suspended",
    },
    statSuspended: {
      ar: "معلّقة",
      en: "Suspended",
    },
    emptySuspended: {
      ar: "لا توجد حزم معلّقة",
      en: "No suspended packages",
    },
    permDeleteBtn: {
      ar: "حذف نهائي",
      en: "Permanent Delete",
    },
    permDeleteHint: {
      ar: "حذف نهائي من الموقع كله (لا يمكن التراجع!)",
      en: "Permanently delete from the entire site (cannot be undone!)",
    },
    confirmPermDelete: {
      ar: "تأكيد الحذف النهائي؟",
      en: "Confirm permanent delete?",
    },
    permDeleteWarning: {
      ar: "⚠️ سيتم حذف هذه الحزمة نهائياً من الموقع ولن يمكن استرجاعها!",
      en: "⚠️ This package will be permanently deleted and cannot be recovered!",
    },
    // ── Admin Panel search ────────────────────────────────────────────────────
    searchPerformers: {
      ar: "بحث عن حزمة بالاسم، الفئة، السعر...",
      en: "Search packages by name, category, price...",
    },
    clearSearch: {
      ar: "مسح البحث",
      en: "Clear search",
    },
    searchResultsFound: {
      ar: "تم العثور على {n} نتيجة",
      en: "{n} result(s) found",
    },
    searchNoResults: {
      ar: "لا توجد نتائج مطابقة",
      en: "No matching results",
    },
    suspendedBadge: {
      ar: "معلّق",
      en: "Suspended",
    },
  },

  // ─────────────────────────── EDIT PROFILE PAGE ───────────────────────────────
  editProfile: {
    pageTitle: {
      ar: "الملف الشخصي",
      en: "Profile",
    },
    editPageTitle: {
      ar: "تعديل الملف الشخصي",
      en: "Edit Profile",
    },
    subtitle: {
      ar: "اجعل ملفك الشخصي يعكس شخصيتك الحقيقية",
      en: "Make your profile reflect your true identity",
    },
    // Sections
    avatarSection: {
      ar: "صورة الملف الشخصي",
      en: "Profile Picture",
    },
    infoSection: {
      ar: "المعلومات الشخصية",
      en: "Personal Information",
    },
    // Fields
    displayNameLabel: {
      ar: "اسم العرض",
      en: "Display Name",
    },
    displayNamePlaceholder: {
      ar: "مثلاً: أبو علي، Shadow، King...",
      en: "e.g. Shadow, King, John...",
    },
    bioLabel: {
      ar: "نبذة تعريفية",
      en: "Bio",
    },
    bioPlaceholder: {
      ar: "أخبر الآخرين عن نفسك...",
      en: "Tell others about yourself...",
    },
    birthdateLabel: {
      ar: "تاريخ الميلاد",
      en: "Date of Birth",
    },
    avatarUrlLabel: {
      ar: "رابط صورة الملف الشخصي",
      en: "Profile Picture URL",
    },
    avatarUrlPlaceholder: {
      ar: "أو أدخل رابط الصورة مباشرة",
      en: "Or enter image URL directly",
    },
    avatarColorLabel: {
      ar: "لون الأفاتار",
      en: "Avatar Color",
    },
    // Buttons
    saveBtn: {
      ar: "حفظ التغييرات",
      en: "Save Changes",
    },
    savingBtn: {
      ar: "جارٍ الحفظ...",
      en: "Saving...",
    },
    uploadBtn: {
      ar: "رفع صورة",
      en: "Upload Photo",
    },
    uploadingBtn: {
      ar: "جارٍ الرفع...",
      en: "Uploading...",
    },
    changePhotoBtn: {
      ar: "تغيير الصورة",
      en: "Change Photo",
    },
    removePhotoBtn: {
      ar: "إزالة الصورة",
      en: "Remove Photo",
    },
    backBtn: {
      ar: "رجوع",
      en: "Back",
    },
    // Success / Error
    savedSuccess: {
      ar: "✓ تم حفظ الملف الشخصي بنجاح",
      en: "✓ Profile saved successfully",
    },
    uploadSuccess: {
      ar: "✓ تم رفع الصورة بنجاح",
      en: "✓ Photo uploaded successfully",
    },
    uploadError: {
      ar: "فشل رفع الصورة. حاول مرة أخرى",
      en: "Failed to upload photo. Please try again",
    },
    saveError: {
      ar: "حدث خطأ أثناء الحفظ. حاول مرة أخرى",
      en: "An error occurred while saving. Please try again",
    },
    // Validation
    nameRequired: {
      ar: "يرجى إدخال اسم العرض",
      en: "Display name is required",
    },
    nameTooShort: {
      ar: "الاسم قصير جداً (حرفان على الأقل)",
      en: "Name is too short (min 2 chars)",
    },
    nameTooLong: {
      ar: "الاسم طويل جداً (20 حرفاً كحد أقصى)",
      en: "Name is too long (max 20 chars)",
    },
    bioTooLong: {
      ar: "النبذة طويلة جداً (150 حرفاً كحد أقصى)",
      en: "Bio is too long (max 150 chars)",
    },
    invalidDate: {
      ar: "تاريخ الميلاد غير صحيح",
      en: "Invalid date of birth",
    },
    invalidUrl: {
      ar: "رابط الصورة غير صحيح",
      en: "Invalid image URL",
    },
    fileTooLarge: {
      ar: "حجم الصورة كبير جداً (5 ميجا كحد أقصى)",
      en: "Image too large (max 5 MB)",
    },
    fileInvalidType: {
      ar: "نوع الملف غير مدعوم (JPG، PNG، GIF فقط)",
      en: "Unsupported file type (JPG, PNG, GIF only)",
    },
    // Guest messages
    guestTitle: {
      ar: "أنت تتصفح كزائر",
      en: "You're browsing as a guest",
    },
    guestSubtitle: {
      ar: "الزوار لا يمكنهم إنشاء ملف شخصي كامل",
      en: "Guests cannot create a full profile",
    },
    guestFeature1: {
      ar: "صورة ملف شخصي مخصصة",
      en: "Custom profile picture",
    },
    guestFeature2: {
      ar: "نبذة تعريفية شخصية",
      en: "Personal bio",
    },
    guestFeature3: {
      ar: "حفظ بياناتك عبر الأجهزة",
      en: "Save your data across devices",
    },
    guestFeature4: {
      ar: "معرّف فريد دائم",
      en: "Permanent unique ID",
    },
    guestFeature5: {
      ar: "تاريخ ميلاد وبيانات كاملة",
      en: "Birthday and full profile data",
    },
    guestRegisterBtn: {
      ar: "سجّل الآن مجاناً",
      en: "Register Now for Free",
    },
    guestLoginBtn: {
      ar: "تسجيل الدخول",
      en: "Sign In",
    },
    guestNameLabel: {
      ar: "تعديل الاسم المؤقت",
      en: "Edit Temporary Name",
    },
    guestNameNote: {
      ar: "هذا الاسم مؤقت ويختفي بعد إغلاق المتصفح",
      en: "This name is temporary and disappears after closing the browser",
    },
    // Info labels
    memberSince: {
      ar: "عضو منذ",
      en: "Member since",
    },
    userId: {
      ar: "المعرّف الفريد",
      en: "Unique ID",
    },
    copied: {
      ar: "تم النسخ!",
      en: "Copied!",
    },
    copyId: {
      ar: "نسخ المعرّف",
      en: "Copy ID",
    },
    // Chars count
    chars: {
      ar: "حرف",
      en: "chars",
    },
    // Image hint
    imageHint: {
      ar: "PNG، JPG أو GIF — 5 ميجا كحد أقصى — سيتم قصها دائرياً",
      en: "PNG, JPG or GIF — max 5 MB — will be cropped to circle",
    },
    // Age calculation
    age: {
      ar: "عمر",
      en: "Age",
    },
    years: {
      ar: "سنة",
      en: "years",
    },
    // ── Gender (الجنس) — للجميع (زوار + مسجلين) ──────────────────────────────
    genderSection: {
      ar: "الجنس",
      en: "Gender",
    },
    genderLabel: {
      ar: "الجنس",
      en: "Gender",
    },
    genderMale: {
      ar: "ذكر",
      en: "Male",
    },
    genderFemale: {
      ar: "أنثى",
      en: "Female",
    },
    genderOther: {
      ar: "أفضل عدم الإفصاح",
      en: "Prefer not to say",
    },
    genderSaved: {
      ar: "✓ تم حفظ الجنس",
      en: "✓ Gender saved",
    },
    genderSaveError: {
      ar: "خطأ في حفظ الجنس",
      en: "Error saving gender",
    },
    // ── @Username المميز — للمسجلين فقط ──────────────────────────────────────
    usernameSection: {
      ar: "اسم المستخدم المميز",
      en: "Unique Username",
    },
    usernameLabel: {
      ar: "اسم المستخدم (@username)",
      en: "Username (@username)",
    },
    usernamePlaceholder: {
      ar: "مثلاً: shadow_x أو king.99",
      en: "e.g. shadow_x or king.99",
    },
    usernameHint: {
      ar: "يُستخدم للتعريف بك بشكل فريد على الموقع. لا يمكن تغييره إلا مرة كل 6 أشهر.",
      en: "Used to uniquely identify you on the site. Can only be changed once every 6 months.",
    },
    usernameRules: {
      ar: "3-20 حرفاً — أحرف إنجليزية، أرقام، نقطة (.) أو شرطة سفلية (_)",
      en: "3-20 chars — English letters, numbers, dot (.) or underscore (_)",
    },
    usernameChecking: {
      ar: "جارٍ التحقق...",
      en: "Checking...",
    },
    usernameAvailable: {
      ar: "✓ متاح",
      en: "✓ Available",
    },
    usernameTaken: {
      ar: "هذا الاسم مأخوذ بالفعل",
      en: "This username is already taken",
    },
    usernameInvalidChars: {
      ar: "يُسمح فقط بالأحرف الإنجليزية، الأرقام، النقطة، والشرطة السفلية",
      en: "Only English letters, numbers, dot, and underscore are allowed",
    },
    usernameTooShort: {
      ar: "اسم المستخدم قصير جداً (3 أحرف على الأقل)",
      en: "Username too short (min 3 chars)",
    },
    usernameTooLong: {
      ar: "اسم المستخدم طويل جداً (20 حرفاً كحد أقصى)",
      en: "Username too long (max 20 chars)",
    },
    usernameInvalidEdge: {
      ar: "لا يمكن أن يبدأ أو ينتهي بنقطة أو شرطة سفلية",
      en: "Cannot start or end with a dot or underscore",
    },
    usernameConsecutive: {
      ar: "لا يمكن استخدام نقطتين أو شرطتين متتاليتين",
      en: "Cannot use consecutive dots or underscores",
    },
    usernameReserved: {
      ar: "هذا الاسم محجوز ولا يمكن استخدامه",
      en: "This username is reserved and cannot be used",
    },
    usernameNetworkError: {
      ar: "خطأ في الشبكة، حاول مرة أخرى",
      en: "Network error, please try again",
    },
    usernameSaveBtn: {
      ar: "تأكيد اسم المستخدم",
      en: "Confirm Username",
    },
    usernameSaving: {
      ar: "جارٍ الحفظ...",
      en: "Saving...",
    },
    usernameSaved: {
      ar: "✓ تم تعيين اسم المستخدم بنجاح",
      en: "✓ Username set successfully",
    },
    usernameSaveError: {
      ar: "خطأ في حفظ اسم المستخدم",
      en: "Error saving username",
    },
    usernameCooldown: {
      ar: "لا يمكنك تغيير اسم المستخدم إلا بعد {days} يوم",
      en: "You can change your username in {days} days",
    },
    usernameCooldownNote: {
      ar: "يمكن تغيير اسم المستخدم مرة واحدة فقط كل 6 أشهر",
      en: "Username can only be changed once every 6 months",
    },
    usernameCurrentLabel: {
      ar: "اسم المستخدم الحالي",
      en: "Current username",
    },
    usernameLockedUntil: {
      ar: "مقفل حتى",
      en: "Locked until",
    },
    usernameChangeWarning: {
      ar: "تحذير: بعد التأكيد لن تستطيع التغيير لمدة 6 أشهر",
      en: "Warning: After confirming you won't be able to change it for 6 months",
    },
    usernameRequired: {
      ar: "يرجى إدخال اسم المستخدم",
      en: "Please enter a username",
    },
    usernameNotSet: {
      ar: "لم يتم تعيين اسم مستخدم بعد",
      en: "No username set yet",
    },
    usernameSetDate: {
      ar: "تم التعيين في",
      en: "Set on",
    },
    usernameCopyBtn: {
      ar: "نسخ",
      en: "Copy",
    },
    usernameCopied: {
      ar: "تم النسخ!",
      en: "Copied!",
    },
    usernameGuestNote: {
      ar: "اسم المستخدم المميز متاح للأعضاء المسجلين فقط",
      en: "Unique username is available for registered members only",
    },
    usernameChangeBtn: {
      ar: "تغيير اسم المستخدم",
      en: "Change Username",
    },
    usernameSameAsCurrent: {
      ar: "هذا هو اسم المستخدم الحالي بالفعل",
      en: "This is already your current username",
    },
  },
};

export default translations;
